export const countries = [
  'CN',
  'AD',
  'AE',
  'AF',
  'AG',
  'AI',
  'AL',
  'AM',
  'AN',
  'AO',
  'AQ',
  'AR',
  'AS',
  'AT',
  'AU',
  'AW',
  'AX',
  'AZ',
  'BA',
  'BB',
  'BD',
  'BE',
  'BF',
  'BG',
  'BH',
  'BI',
  'BJ',
  'BL',
  'BM',
  'BN',
  'BO',
  'BQ',
  'BR',
  'BS',
  'BT',
  'BV',
  'BW',
  'BY',
  'BZ',
  'CA',
  'CC',
  'CD',
  'CF',
  'CG',
  'CH',
  'CI',
  'CK',
  'CL',
  'CM',
  'CO',
  'CR',
  'CS',
  'CT',
  'CU',
  'CV',
  'CX',
  'CY',
  'CZ',
  'DD',
  'DE',
  'DJ',
  'DK',
  'DM',
  'DO',
  'DZ',
  'EC',
  'EE',
  'EG',
  'EH',
  'ER',
  'ES',
  'ET',
  'FI',
  'FJ',
  'FK',
  'FM',
  'FO',
  'FQ',
  'FR',
  'FX',
  'GA',
  'GB',
  'GD',
  'GE',
  'GF',
  'GG',
  'GH',
  'GI',
  'GL',
  'GM',
  'GN',
  'GP',
  'GQ',
  'GR',
  'GS',
  'GT',
  'GU',
  'GW',
  'GY',
  'HK',
  'HM',
  'HN',
  'HR',
  'HT',
  'HU',
  'ID',
  'IE',
  'IL',
  'IM',
  'IN',
  'IO',
  'IQ',
  'IR',
  'IS',
  'IT',
  'JE',
  'JM',
  'JO',
  'JP',
  'JT',
  'KE',
  'KG',
  'KH',
  'KI',
  'KM',
  'KN',
  'KP',
  'KR',
  'KW',
  'KY',
  'KZ',
  'LA',
  'LB',
  'LC',
  'LI',
  'LK',
  'LR',
  'LS',
  'LT',
  'LU',
  'LV',
  'LY',
  'MA',
  'MC',
  'MD',
  'ME',
  'MF',
  'MG',
  'MH',
  'MI',
  'MK',
  'ML',
  'MM',
  'MN',
  'MO',
  'MP',
  'MQ',
  'MR',
  'MS',
  'MT',
  'MU',
  'MV',
  'MW',
  'MX',
  'MY',
  'MZ',
  'NA',
  'NC',
  'NE',
  'NF',
  'NG',
  'NI',
  'NL',
  'NO',
  'NP',
  'NQ',
  'NR',
  'NT',
  'NU',
  'NZ',
  'OM',
  'PA',
  'PC',
  'PE',
  'PF',
  'PG',
  'PH',
  'PK',
  'PL',
  'PM',
  'PN',
  'PR',
  'PS',
  'PT',
  'PU',
  'PW',
  'PY',
  'PZ',
  'QA',
  'QO',
  'QU',
  'RE',
  'RO',
  'RS',
  'RU',
  'RW',
  'SA',
  'SB',
  'SC',
  'SD',
  'SE',
  'SG',
  'SH',
  'SI',
  'SJ',
  'SK',
  'SL',
  'SM',
  'SN',
  'SO',
  'SR',
  'ST',
  'SU',
  'SV',
  'SY',
  'SZ',
  'TC',
  'TD',
  'TF',
  'TG',
  'TH',
  'TJ',
  'TK',
  'TL',
  'TM',
  'TN',
  'TO',
  'TR',
  'TT',
  'TV',
  'TW',
  'TZ',
  'UA',
  'UG',
  'UM',
  'US',
  'UY',
  'UZ',
  'VA',
  'VC',
  'VD',
  'VE',
  'VG',
  'VI',
  'VN',
  'VU',
  'WF',
  'WK',
  'WS',
  'YD',
  'YE',
  'YT',
  'YK',
  'ZA',
  'ZM',
  'ZW',
  'RA',
];

export const flagsWithNone = [
  'red',
  'orange',
  'yellow',
  'green',
  'cyan',
  'blue',
  'purple',
  'none',
];
export const flagsWithClear = [
  'red',
  'orange',
  'yellow',
  'green',
  'cyan',
  'blue',
  'purple',
  'clear',
];
export const customerTypes = ['wholesale', 'retail'];
export const settleTypes = ['now', 'later'];
export const referencesProduct = [
  { name: '货号', value: '${货号}' },
  { name: '货号二维码', value: '${货号二维码}' },
  { name: '单位', value: '${单位}' },
  { name: '分类', value: '${分类}' },
  { name: '品牌', value: '${品牌}' },
  { name: '售价', value: '${售价}' },
  { name: '批发价', value: '${批发价}' },
  { name: '售价带规格', value: '${售价带规格}' },
  { name: '批发价带规格', value: '${批发价带规格}' },
  { name: '主料', value: '${主料}' },
  { name: '颜色', value: '${颜色}' },
  { name: '规格', value: '${规格}' },
];
export const referencesSaleSlip = [
  { name: '订单号', value: '${订单号}' },
  { name: '销售额', value: '${销售额}' },
  { name: '成交额', value: '${成交额}' },
  { name: '收款类型', value: '${收款类型}' },
  { name: '收款额', value: '${收款额}' },
  { name: '抹零额', value: '${抹零额}' },
  { name: '欠款额', value: '${欠款额}' },
  { name: '创建日期', value: '${创建日期}' },
  { name: '销售', value: '${ 销售 }' },
  { name: '发货备注', value: '${发货备注}' },
  { name: '订单备注', value: '${订单备注}' },
  { name: '客户姓名', value: '${客户姓名}' },
  { name: '客户电话', value: '${客户电话}' },
  { name: '客户国家', value: '${客户国家}' },
  { name: '客户省份', value: '${客户省份}' },
  { name: '客户城市', value: '${客户城市}' },
  { name: '客户地址', value: '${客户地址}' },
  { name: '客户邮编', value: '${客户邮编}' },
  { name: '收款方式', value: '${收款方式}' },
  { name: '订单项', value: '${订单项}' },
  { name: '精简订单项', value: '${精简订单项}' },
  { name: '订单项', value: '${带图片订单项}' },
  { name: '精简订单项', value: '${带图片精简订单项}' },
  { name: '订单项5', value: '${订单项5}' },
];
export const referencesRentSlip = [
  { name: '租赁单号', value: '${租赁单号}' },
  { name: '租赁额', value: '${租赁额}' },
  { name: '收款额', value: '${收款额}' },
  { name: '欠款额', value: '${欠款额}' },
  { name: '创建日期', value: '${创建日期}' },
  { name: '开始日期', value: '${开始日期}' },
  { name: '结束日期', value: '${结束日期}' },
  { name: '销售', value: '${销售}' },
  { name: '租赁单备注', value: '${租赁单备注}' },
  { name: '客户姓名', value: '${客户姓名}' },
  { name: '客户电话', value: '${客户电话}' },
  { name: '客户国家', value: '${客户国家}' },
  { name: '客户省份', value: '${客户省份}' },
  { name: '客户城市', value: '${客户城市}' },
  { name: '客户地址', value: '${客户地址}' },
  { name: '客户邮编', value: '${客户邮编}' },
  { name: '收款方式', value: '${收款方式}' },
  { name: '租赁单项', value: '${租赁单项}' },
  { name: '精简租赁单项', value: '${精简租赁单项}' },
];
export const referencesWorkOrder = [
  { name: '客户', value: '${客户}' },
  { name: '产线', value: '${产线}' },
  { name: '工单号', value: '${工单号}' },
  { name: '工单号二维码', value: '${工单号二维码}' },
  { name: '库存码', value: '${库存码}' },
  // { name: '工单号条形码', value: '${工单号条形码}' },
  { name: '交货日期', value: '${交货日期}' },
  { name: '计划完成日期', value: '${计划完成日期}' },
  { name: '货号', value: '${货号}' },
  { name: '货号二维码', value: '${货号二维码}' },
  { name: '颜色', value: '${颜色}' },
  { name: '颜色图片', value: '${颜色图片}' },
  { name: '规格', value: '${规格}' },
  { name: '分类', value: '${分类}' },
  { name: '品牌', value: '${品牌}' },
  { name: '数量', value: '${数量}' },
  { name: '自定义属性', value: '${自定义属性}' },
  { name: '自定义属性', value: '${自定义属性竖版}' },
  { name: '制作工艺', value: '${制作工艺}' },
  { name: '订单备注', value: '${订单备注}' },
  { name: '第一张图片(大图)', value: '${大图}' },
  { name: '第二张图片(大图)', value: '${大图2}' },
  { name: '图片(小图)', value: '${小图}' },
  { name: '工序', value: '${工序}' },
  { name: '工序(带计划完成时间)', value: '${工序带时间}' },
  { name: '下单日期', value: '${下单日期}' },
  { name: '派单日期', value: '${派单日期}' },
  { name: '经办部门', value: '${经办部门}' },
  { name: '经办人', value: '${经办人}' },
  { name: '订单分组', value: '${订单分组}' },
  { name: '附件', value: '${附件}' },
  { name: '加急', value: '${加急}' },
  { name: '内部单号', value: '${内部单号}' },
  { name: '客户货号', value: '${客户货号}' },
  { name: '工序分组', value: '${工序分组}' },
  { name: '终端客户名称', value: '${终端客户名称}' },
  { name: '终端售价', value: '${终端售价}' },
  { name: '同订单其他工单号', value: '${同订单其他工单号}' },
];

// oms 订单管理
// rms 租赁单
// schedule 日程管理
// salesTarget 销售目标
// pms 外采管理
// lmsC 货代发货
// lmsE 快递发货
// lmsO 送货自提
// mms 物料管理
// mes 生产管理
// wms 库存管理
// pdm 产品中心
// adapterI 国际对接
// adapterC 国内对接
// report 财务报表
// mall 赢小店

export const economyServices = [
  {
    delivery_address: '江苏省苏州市吴中区开发区 兴吴路58号',
    logistics_service_id: 'CAINIAO_STANDARD_SG_12712451',
    logistics_service_name: '菜鸟特货专线－标准',
    warehouse_name: '燕文苏州仓-标准',
  },
  {
    delivery_address:
      '福建省福州市仓山区盖山镇 白湖亭埔下路仓山科技园区 V-03号 兴福兴大厦综合楼北楼一层',
    logistics_service_id: 'CAINIAO_STANDARD_SG_1214507',
    logistics_service_name: '菜鸟特货专线－标准',
    warehouse_name: '递四方福州仓-标准',
  },
  {
    delivery_address: '广东省汕头市金平区广厦街道 浮东路段蔡厝洋工业区26号',
    logistics_service_id: 'CAINIAO_STANDARD_SG_1214535',
    logistics_service_name: '菜鸟特货专线－标准',
    warehouse_name: '递四方汕头仓-标准',
  },
  {
    delivery_address:
      '河南省南阳市卧龙区百里奚街道 百里奚北路热电厂东隔墙永发酒店管理有限责任公司C座一楼8--12号',
    logistics_service_id: 'CAINIAO_STANDARD_SG_13477142',
    logistics_service_name: '菜鸟特货专线－标准',
    warehouse_name: '燕文南阳仓',
  },
  {
    delivery_address:
      '北京北京市顺义区南法信镇 顺畅大道16号的普洛斯北京空港物流园，位于项目的B4号库（物业）D区南侧单元，燕文物流',
    logistics_service_id: 'CAINIAO_STANDARD_SG_1710058',
    logistics_service_name: '菜鸟特货专线－标准',
    warehouse_name: '燕文北京仓-标准',
  },
  {
    delivery_address:
      '福建省莆田市荔城区黄石镇 七境村林芝路189号双赢物流园基地11号楼1层东南侧（递四方速递无忧莆田仓）',
    logistics_service_id: 'CAINIAO_STANDARD_SG_13173082',
    logistics_service_name: '菜鸟特货专线－标准',
    warehouse_name: '递四方莆田仓-标准',
  },
  {
    delivery_address: '江苏省无锡市惠山区无锡惠山经济开发区 智慧路21号',
    logistics_service_id: 'CAINIAO_STANDARD_SG_12712242',
    logistics_service_name: '菜鸟特货专线－标准',
    warehouse_name: '燕文无锡仓-标准',
  },
  {
    delivery_address:
      '广东省惠州市惠城区马安镇 惠州市惠城区马安镇新乐工业区4路第十小区D12号一层',
    logistics_service_id: 'CAINIAO_STANDARD_SG_13171478',
    logistics_service_name: '菜鸟特货专线－标准',
    warehouse_name: '递四方惠州仓-标准',
  },
  {
    delivery_address: '河北省保定市高碑店市白沟镇 CT机工业园合欢路32号东门',
    logistics_service_id: 'CAINIAO_STANDARD_SG_13171474',
    logistics_service_name: '菜鸟特货专线－标准',
    warehouse_name: '燕文保定仓-标准',
  },
  {
    delivery_address:
      '四川省成都市新都区新都镇 中集大道71号普洛斯新都物流园B3-204-5号门',
    logistics_service_id: 'CAINIAO_STANDARD_SG_13173894',
    logistics_service_name: '菜鸟特货专线－标准',
    warehouse_name: '燕文成都仓-标准',
  },
  {
    delivery_address:
      '天津天津市东丽区东丽区开发区 天津市东丽区一经路信通路天津市永珍电子厂院内',
    logistics_service_id: 'CAINIAO_STANDARD_SG_13208965',
    logistics_service_name: '菜鸟特货专线－标准',
    warehouse_name: '燕文天津仓-标准',
  },
  {
    delivery_address:
      '浙江省金华市义乌市稠江街道 龙海路825号普洛斯物流园A1-U4区',
    logistics_service_id: 'CAINIAO_STANDARD_SG_1709669',
    logistics_service_name: '菜鸟特货专线－标准',
    warehouse_name: '燕文义乌仓-标准',
  },
  {
    delivery_address:
      '广东省东莞市沙田镇 东莞市沙田镇进港南路231号启盈后面菜鸟AE华南定制仓2号物流仓库一楼',
    logistics_service_id: 'CAINIAO_STANDARD_SG_FPXGZ',
    logistics_service_name: '菜鸟特货专线－标准',
    warehouse_name: '递四方广州仓-标准',
  },
  {
    delivery_address: '广东省中山市沙溪镇 涌头南康街49号1幢首层之2-7卡',
    logistics_service_id: 'CAINIAO_STANDARD_SG_11991628',
    logistics_service_name: '菜鸟特货专线－标准',
    warehouse_name: '递四方珠海仓-标准',
  },
  {
    delivery_address: '浙江省宁波市江北区洪塘街道 洪兴路6号',
    logistics_service_id: 'CAINIAO_STANDARD_SG_1731793',
    logistics_service_name: '菜鸟特货专线－标准',
    warehouse_name: '燕文宁波仓-标准',
  },
  {
    delivery_address: '浙江省杭州市萧山区萧山空港经济区 保税物流园8号仓',
    logistics_service_id: 'CAINIAO_STANDARD_SG_1731791',
    logistics_service_name: '菜鸟特货专线－标准',
    warehouse_name: '燕文杭州仓-标准',
  },
  {
    delivery_address:
      '上海上海市青浦区徐泾镇 （本地址不支持自寄或自送，下单时系统会自动匹配出最优交接仓地址，如杭州或者东莞出口口岸仓地址）',
    logistics_service_id: 'CAINIAO_STANDARD_SG_30140861',
    logistics_service_name: '菜鸟特货专线－标准',
    warehouse_name: '申通国际-揽收仓',
  },
  {
    delivery_address:
      '广东省东莞市沙田镇 东莞市沙田镇进港南路231号启盈后面菜鸟AE华南定制仓2号物流仓库一楼',
    logistics_service_id: 'CAINIAO_STANDARD_SG_1214478',
    logistics_service_name: '菜鸟特货专线－标准',
    warehouse_name: '递四方佛山仓-标准',
  },
  {
    delivery_address: '江苏省南京市江宁区秣陵街道 将军大道开拓路18号东一楼',
    logistics_service_id: 'CAINIAO_STANDARD_SG_11993143',
    logistics_service_name: '菜鸟特货专线－标准',
    warehouse_name: '燕文南京仓-标准',
  },
  {
    delivery_address:
      '广东省深圳市宝安区松岗街道 松岗大道1号2栋一楼（四方邮局）',
    logistics_service_id: 'CAINIAO_STANDARD_SG_FPXSS',
    logistics_service_name: '菜鸟特货专线－标准',
    warehouse_name: '递四方深圳仓-标准',
  },
  {
    delivery_address:
      '福建省泉州市丰泽区东海街道 东海滨城通港东街533号（临江雕塑工艺厂内）',
    logistics_service_id: 'CAINIAO_STANDARD_SG_1214631',
    logistics_service_name: '菜鸟特货专线－标准',
    warehouse_name: '递四方泉州仓-标准',
  },
  {
    delivery_address:
      '福建省厦门市集美区灌口镇 航天路155-6号之一（原玉柴厂区6号厂房）内）',
    logistics_service_id: 'CAINIAO_STANDARD_SG_FPXXM',
    logistics_service_name: '菜鸟特货专线－标准',
    warehouse_name: '递四方厦门仓-标准',
  },
  {
    delivery_address: '辽宁省葫芦岛市兴城市宁远街道 铁道西21号',
    logistics_service_id: 'CAINIAO_STANDARD_SG_13174093',
    logistics_service_name: '菜鸟特货专线－标准',
    warehouse_name: '燕文葫芦岛仓-标准',
  },
  {
    delivery_address:
      '重庆重庆市九龙坡区石桥铺街道 二郎凯邦支路16号惠凌实业仓库大楼6楼14号',
    logistics_service_id: 'CAINIAO_STANDARD_SG_13322913',
    logistics_service_name: '菜鸟特货专线－标准',
    warehouse_name: '燕文重庆仓-标准',
  },
  {
    delivery_address:
      '河南省郑州市其它区 九龙镇凤河东路普洛斯园区A-3库燕文物流',
    logistics_service_id: 'CAINIAO_STANDARD_SG_12350032',
    logistics_service_name: '菜鸟特货专线－标准',
    warehouse_name: '燕文郑州仓-标准',
  },
  {
    delivery_address:
      '湖北省武汉市东西湖区径河街道 新城十三路中原物流园B\\/16-24号递四方速递',
    logistics_service_id: 'CAINIAO_STANDARD_SG_30500252',
    logistics_service_name: '菜鸟特货专线－标准',
    warehouse_name: '递四方武汉仓-揽收',
  },
  {
    delivery_address: '江苏省苏州市昆山市花桥镇 花集路668号宝湾物流1号库6号门',
    logistics_service_id: 'CAINIAO_STANDARD_SG_1710315',
    logistics_service_name: '菜鸟特货专线－标准',
    warehouse_name: '燕文上海仓-标准',
  },
  {
    delivery_address: '浙江省温州市龙湾区海滨街道 滨海园区3道4299号一号楼1楼',
    logistics_service_id: 'CAINIAO_STANDARD_SG_1710319',
    logistics_service_name: '菜鸟特货专线－标准',
    warehouse_name: '燕文温州仓-标准',
  },
  {
    delivery_address: '广东省中山市沙溪镇 涌头南康街49号1幢首层之2-7卡',
    logistics_service_id: 'CAINIAO_STANDARD_SG_11909302',
    logistics_service_name: '菜鸟特货专线－标准',
    warehouse_name: '递四方中山仓-标准',
  },
  {
    delivery_address:
      '安徽省合肥市蜀山区蜀山新产业园区 仰桥路381号向东50米5号仓',
    logistics_service_id: 'CAINIAO_STANDARD_SG_13207156',
    logistics_service_name: '菜鸟特货专线－标准',
    warehouse_name: '燕文合肥仓-标准',
  },
  {
    delivery_address: '江苏省苏州市昆山市花桥镇 花集路668号宝湾物流1号库11号门',
    logistics_service_id: 'CAINIAO_STANDARD_SG_13172662',
    logistics_service_name: '菜鸟特货专线－标准',
    warehouse_name: '燕文昆山仓-标准',
  },
  {
    delivery_address:
      '河北省石家庄市裕华区裕翔街道 与贾商路交叉口北行100米路东',
    logistics_service_id: 'CAINIAO_STANDARD_SG_13476647',
    logistics_service_name: '菜鸟特货专线－标准',
    warehouse_name: '燕文石家庄仓',
  },
  {
    delivery_address:
      '山东省青岛市李沧区虎山路街道 黑龙江中路398号中艺1688创意产业园D2座105-108',
    logistics_service_id: 'CAINIAO_STANDARD_SG_1214596',
    logistics_service_name: '菜鸟特货专线－标准',
    warehouse_name: '递四方青岛仓-标准',
  },
  {
    delivery_address:
      '广东省东莞市沙田镇 进港南路231号启盈后面菜鸟AE华南定制仓2号物流仓库一楼',
    logistics_service_id: 'CAINIAO_STANDARD_SG_1214593',
    logistics_service_name: '菜鸟特货专线－标准',
    warehouse_name: '递四方东莞仓-标准',
  },
  {
    delivery_address: '江西省南昌市南昌县昌东镇 创新三路199号  燕文物流',
    logistics_service_id: 'CAINIAO_STANDARD_SG_13208896',
    logistics_service_name: '菜鸟特货专线－标准',
    warehouse_name: '燕文南昌仓-标准',
  },
  {
    delivery_address:
      '湖南省长沙市天心区黑石铺街道 新开铺路960号院内递四方速递',
    logistics_service_id: 'CAINIAO_STANDARD_SG_12720687',
    logistics_service_name: '菜鸟特货专线－标准',
    warehouse_name: '递四方长沙仓-标准',
  },
  {
    delivery_address: '上海市青浦区华新镇华志路1295弄888号(邮编201700)',
    logistics_service_id: 'BF#BF_SH#ARAMEX#ARAMEX',
    logistics_service_name: 'ARAMEX',
    logistics_timeliness: '8 - 15天',
    warehouse_name: '博丰上海仓',
  },
  {
    delivery_address: '浙江省温州市龙湾区蒲州街道奉江路39号',
    logistics_service_id: 'BSWL#BSWL_WZ#ARAMEX#ARAMEX',
    logistics_service_name: 'ARAMEX',
    logistics_timeliness: '8 - 15天',
    warehouse_name: '佰首温州仓',
  },
  {
    delivery_address: '上海市青浦区华新镇华志路1295弄888号(邮编201700)',
    logistics_service_id: 'BF#BF_SH#UPS-Saver#UPS',
    logistics_service_name: 'UPS Saver',
    logistics_timeliness: '4 - 7天',
    warehouse_name: '博丰上海仓',
  },
  {
    delivery_address: '上海市青浦区华新镇华志路1295弄888号(邮编201700)',
    logistics_service_id: 'BF#BF_SH#FedEx-IP#FEDEX',
    logistics_service_name: 'FedEx IP',
    logistics_timeliness: '3 - 7天',
    warehouse_name: '博丰上海仓',
  },
  {
    delivery_address:
      '杭州市萧山经济开发区桥南区鸿兴路109号1号楼1楼（跨境贸易电子商务服务区）',
    logistics_service_id: 'BSWL#BSWL_HZ#UPS-Saver#UPS',
    logistics_service_name: 'UPS Saver',
    logistics_timeliness: '4 - 7天',
    warehouse_name: '佰首杭州仓',
  },
  {
    delivery_address: '深圳市光明区马田街道金安路75号易通关物流园 邮编:518106',
    logistics_service_id: 'BDT#BDT_SZ#HKDHL#HKDHL',
    logistics_service_name: 'HK DHL',
    logistics_timeliness: '4 - 9天',
    warehouse_name: '八达通深圳仓',
  },
  {
    delivery_address: '义乌市稠江街道杨村路281号创佳电商园5号楼2单元1楼',
    logistics_service_id: 'BSWL#BSWL_YW#FedEx-IP#FEDEX',
    logistics_service_name: 'FedEx IP',
    logistics_timeliness: '3 - 7天',
    warehouse_name: '佰首义乌仓',
  },
  {
    delivery_address: '山东省青岛市胶州市云兴路营海工业园6号',
    logistics_service_id: 'BSWL#BSWL_QD#UPS-Saver#UPS',
    logistics_service_name: 'UPS Saver',
    logistics_timeliness: '4 - 7天',
    warehouse_name: '佰首青岛仓',
  },
  {
    delivery_address: '义乌市稠江街道杨村路281号创佳电商园5号楼2单元1楼',
    logistics_service_id: 'BSWL#BSWL_YW#ARAMEX#ARAMEX',
    logistics_service_name: 'ARAMEX',
    logistics_timeliness: '8 - 15天',
    warehouse_name: '佰首义乌仓',
  },
  {
    delivery_address:
      '杭州市萧山经济开发区桥南区鸿兴路109号1号楼1楼（跨境贸易电子商务服务区）',
    logistics_service_id: 'BSWL#BSWL_HZ#FedEx-IP#FEDEX',
    logistics_service_name: 'FedEx IP',
    logistics_timeliness: '3 - 7天',
    warehouse_name: '佰首杭州仓',
  },
  {
    delivery_address: '义乌市稠江街道杨村路281号创佳电商园5号楼2单元1楼',
    logistics_service_id: 'BSWL#BSWL_YW#UPS-Saver#UPS',
    logistics_service_name: 'UPS Saver',
    logistics_timeliness: '4 - 7天',
    warehouse_name: '佰首义乌仓',
  },
  {
    delivery_address:
      '许昌市魏都区阳光大道与延安路交叉口东200米路南佑鼎科技院内三号门阿里巴巴许昌仓',
    logistics_service_id: 'BSWL#BSWL_XC#UPS-Saver#UPS',
    logistics_service_name: 'UPS Saver',
    logistics_timeliness: '4 - 7天',
    warehouse_name: '佰首许昌仓',
  },
  {
    delivery_address: '上海市青浦区 北青公路3880号2号厂房一层',
    logistics_service_id: 'BSWL#BSWL_SH#FedEx-IP#FEDEX',
    logistics_service_name: 'FedEx IP',
    logistics_timeliness: '3 - 7天',
    warehouse_name: '佰首上海仓',
  },
  {
    delivery_address: '浙江省温州市龙湾区蒲州街道奉江路39号',
    logistics_service_id: 'BSWL#BSWL_WZ#FedEx-IP#FEDEX',
    logistics_service_name: 'FedEx IP',
    logistics_timeliness: '3 - 7天',
    warehouse_name: '佰首温州仓',
  },
  {
    delivery_address: '山东省青岛市胶州市云兴路营海工业园6号',
    logistics_service_id: 'BSWL#BSWL_QD#ARAMEX#ARAMEX',
    logistics_service_name: 'ARAMEX',
    logistics_timeliness: '8 - 15天',
    warehouse_name: '佰首青岛仓',
  },
  {
    delivery_address: '上海市青浦区 北青公路3880号2号厂房一层',
    logistics_service_id: 'BSWL#BSWL_SH#ARAMEX#ARAMEX',
    logistics_service_name: 'ARAMEX',
    logistics_timeliness: '8 - 15天',
    warehouse_name: '佰首上海仓',
  },
  {
    delivery_address: '山东省青岛市胶州市云兴路营海工业园6号',
    logistics_service_id: 'BSWL#BSWL_QD#FedEx-IP#FEDEX',
    logistics_service_name: 'FedEx IP',
    logistics_timeliness: '3 - 7天',
    warehouse_name: '佰首青岛仓',
  },
  {
    delivery_address: '上海市青浦区 北青公路3880号2号厂房一层',
    logistics_service_id: 'BSWL#BSWL_SH#UPS-Saver#UPS',
    logistics_service_name: 'UPS Saver',
    logistics_timeliness: '4 - 7天',
    warehouse_name: '佰首上海仓',
  },
  {
    delivery_address:
      '杭州市萧山经济开发区桥南区鸿兴路109号1号楼1楼（跨境贸易电子商务服务区）',
    logistics_service_id: 'BSWL#BSWL_HZ#ARAMEX#ARAMEX',
    logistics_service_name: 'ARAMEX',
    logistics_timeliness: '8 - 15天',
    warehouse_name: '佰首杭州仓',
  },
  {
    delivery_address:
      '许昌市魏都区阳光大道与延安路交叉口东200米路南佑鼎科技院内三号门阿里巴巴许昌仓',
    logistics_service_id: 'BSWL#BSWL_XC#ARAMEX#ARAMEX',
    logistics_service_name: 'ARAMEX',
    logistics_timeliness: '8 - 15天',
    warehouse_name: '佰首许昌仓',
  },
  {
    delivery_address: '浙江省温州市龙湾区蒲州街道奉江路39号',
    logistics_service_id: 'BSWL#BSWL_WZ#UPS-Saver#UPS',
    logistics_service_name: 'UPS Saver',
    logistics_timeliness: '4 - 7天',
    warehouse_name: '佰首温州仓',
  },
  {
    delivery_address: '深圳市光明区马田街道金安路75号易通关物流园 邮编:518106',
    logistics_service_id: 'BDT#BDT_SZ#UPS-Saver#UPS',
    logistics_service_name: 'UPS Saver',
    logistics_timeliness: '4 - 7天',
    warehouse_name: '八达通深圳仓',
  },
];
export const standardServices = [
  {
    delivery_address:
      '福建省泉州市丰泽区东海街道 东海滨城通港东街533号（临江雕塑工艺厂内）',
    logistics_service_id: 'CAINIAO_STANDARD_FPXQZ',
    logistics_service_name: 'AliExpress 无忧物流-标准',
    logistics_timeliness: '预计15-45天送达',
    warehouse_name: '递四方泉州仓-标准',
  },
  {
    delivery_address:
      '河南省郑州市其它区 九龙镇凤河东路普洛斯园区A-3库燕文物流',
    logistics_service_id: 'CAINIAO_STANDARD_TS_12350032',
    logistics_service_name: 'AliExpress 无忧物流-标准',
    logistics_timeliness: '预计15-45天送达',
    warehouse_name: '燕文郑州仓-标准',
  },
  {
    delivery_address: '江苏省南京市江宁区秣陵街道 将军大道开拓路18号东一楼',
    logistics_service_id: 'CAINIAO_STANDARD_YANWENNJ',
    logistics_service_name: 'AliExpress 无忧物流-标准',
    logistics_timeliness: '预计15-45天送达',
    warehouse_name: '燕文南京仓-标准',
  },
  {
    delivery_address: '浙江省宁波市江北区洪塘街道 洪兴路6号',
    logistics_service_id: 'CAINIAO_STANDARD_TS_1731793',
    logistics_service_name: 'AliExpress 无忧物流-标准',
    logistics_timeliness: '预计15-45天送达',
    warehouse_name: '燕文宁波仓-标准',
  },
  {
    delivery_address: '浙江省杭州市萧山区萧山空港经济区 保税物流园8号仓',
    logistics_service_id: 'CAINIAO_STANDARD_TS_1731791',
    logistics_service_name: 'AliExpress 无忧物流-标准',
    logistics_timeliness: '预计15-45天送达',
    warehouse_name: '燕文杭州仓-标准',
  },
  {
    delivery_address:
      '重庆重庆市九龙坡区石桥铺街道 二郎凯邦支路16号惠凌实业仓库大楼6楼14号',
    logistics_service_id: 'CAINIAO_STANDARD_TS_13322913',
    logistics_service_name: 'AliExpress 无忧物流-标准',
    logistics_timeliness: '预计15-45天送达',
    warehouse_name: '燕文重庆仓-标准',
  },
  {
    delivery_address: '辽宁省葫芦岛市兴城市宁远街道 铁道西21号',
    logistics_service_id: 'CAINIAO_STANDARD_TS_13174093',
    logistics_service_name: 'AliExpress 无忧物流-标准',
    logistics_timeliness: '预计15-45天送达',
    warehouse_name: '燕文葫芦岛仓-标准',
  },
  {
    delivery_address:
      '浙江省金华市义乌市稠江街道 龙海路825号普洛斯物流园A1-U4区',
    logistics_service_id: 'CAINIAO_STANDARD_TS_1709669',
    logistics_service_name: 'AliExpress 无忧物流-标准',
    logistics_timeliness: '预计15-45天送达',
    warehouse_name: '燕文义乌仓-标准',
  },
  {
    delivery_address: '江苏省苏州市昆山市花桥镇 花集路668号宝湾物流1号库11号门',
    logistics_service_id: 'CAINIAO_STANDARD_TS_13172662',
    logistics_service_name: 'AliExpress 无忧物流-标准',
    logistics_timeliness: '预计15-45天送达',
    warehouse_name: '燕文昆山仓-标准',
  },
  {
    delivery_address: '江苏省无锡市惠山区无锡惠山经济开发区 智慧路21号',
    logistics_service_id: 'CAINIAO_STANDARD_TS_12712242',
    logistics_service_name: 'AliExpress 无忧物流-标准',
    logistics_timeliness: '预计15-45天送达',
    warehouse_name: '燕文无锡仓-标准',
  },
  {
    delivery_address:
      '山东省青岛市李沧区虎山路街道 黑龙江中路398号中艺1688创意产业园D2座105-108',
    logistics_service_id: 'CAINIAO_STANDARD_FPXQD',
    logistics_service_name: 'AliExpress 无忧物流-标准',
    logistics_timeliness: '预计15-45天送达',
    warehouse_name: '递四方青岛仓-标准',
  },
  {
    delivery_address: '江西省南昌市南昌县昌东镇 创新三路199号  燕文物流',
    logistics_service_id: 'CAINIAO_STANDARD_TS_13208896',
    logistics_service_name: 'AliExpress 无忧物流-标准',
    logistics_timeliness: '预计15-45天送达',
    warehouse_name: '燕文南昌仓-标准',
  },
  {
    delivery_address: '江苏省苏州市吴中区开发区 兴吴路58号',
    logistics_service_id: 'CAINIAO_STANDARD_TS_12712451',
    logistics_service_name: 'AliExpress 无忧物流-标准',
    logistics_timeliness: '预计15-45天送达',
    warehouse_name: '燕文苏州仓-标准',
  },
  {
    delivery_address:
      '北京北京市顺义区南法信镇 顺畅大道16号的普洛斯北京空港物流园，位于项目的B4号库（物业）D区南侧单元，燕文物流',
    logistics_service_id: 'CAINIAO_STANDARD_TS_1710058',
    logistics_service_name: 'AliExpress 无忧物流-标准',
    logistics_timeliness: '预计15-45天送达',
    warehouse_name: '燕文北京仓-标准',
  },
  {
    delivery_address:
      '广东省东莞市沙田镇 进港南路231号启盈后面菜鸟AE华南定制仓2号物流仓库一楼',
    logistics_service_id: 'CAINIAO_STANDARD_FPXDG',
    logistics_service_name: 'AliExpress 无忧物流-标准',
    logistics_timeliness: '预计15-45天送达',
    warehouse_name: '递四方东莞仓-标准',
  },
  {
    delivery_address:
      '湖北省武汉市东西湖区径河街道 新城十三路中原物流园B\\/16-24号递四方速递',
    logistics_service_id: 'CAINIAO_STANDARD_30500252',
    logistics_service_name: 'AliExpress 无忧物流-标准',
    logistics_timeliness: '预计15-45天送达',
    warehouse_name: '递四方武汉仓-揽收',
  },
  {
    delivery_address: '广东省汕头市金平区广厦街道 浮东路段蔡厝洋工业区26号',
    logistics_service_id: 'CAINIAO_STANDARD_FPXST',
    logistics_service_name: 'AliExpress 无忧物流-标准',
    logistics_timeliness: '预计15-45天送达',
    warehouse_name: '递四方汕头仓-标准',
  },
  {
    delivery_address: '广东省中山市沙溪镇 涌头南康街49号1幢首层之2-7卡',
    logistics_service_id: 'CAINIAO_STANDARD_FPXZS',
    logistics_service_name: 'AliExpress 无忧物流-标准',
    logistics_timeliness: '预计15-45天送达',
    warehouse_name: '递四方中山仓-标准',
  },
  {
    delivery_address:
      '河北省石家庄市裕华区裕翔街道 与贾商路交叉口北行100米路东',
    logistics_service_id: 'CAINIAO_STANDARD_TS_13476647',
    logistics_service_name: 'AliExpress 无忧物流-标准',
    logistics_timeliness: '预计15-45天送达',
    warehouse_name: '燕文石家庄仓',
  },
  {
    delivery_address:
      '安徽省合肥市蜀山区蜀山新产业园区 仰桥路381号向东50米5号仓',
    logistics_service_id: 'CAINIAO_STANDARD_TS_13207156',
    logistics_service_name: 'AliExpress 无忧物流-标准',
    logistics_timeliness: '预计15-45天送达',
    warehouse_name: '燕文合肥仓-标准',
  },
  {
    delivery_address:
      '福建省福州市仓山区盖山镇 白湖亭埔下路仓山科技园区 V-03号 兴福兴大厦综合楼北楼一层',
    logistics_service_id: 'CAINIAO_STANDARD_FPXFZ',
    logistics_service_name: 'AliExpress 无忧物流-标准',
    logistics_timeliness: '预计15-45天送达',
    warehouse_name: '递四方福州仓-标准',
  },
  {
    delivery_address:
      '湖南省长沙市天心区黑石铺街道 新开铺路960号院内递四方速递',
    logistics_service_id: 'CAINIAO_STANDARD_TS_12720687',
    logistics_service_name: 'AliExpress 无忧物流-标准',
    logistics_timeliness: '预计15-45天送达',
    warehouse_name: '递四方长沙仓-标准',
  },
  {
    delivery_address:
      '上海上海市青浦区徐泾镇 （本地址不支持自寄或自送，下单时系统会自动匹配出最优交接仓地址，如杭州或者东莞出口口岸仓地址）',
    logistics_service_id: 'CAINIAO_STANDARD_30140861',
    logistics_service_name: 'AliExpress 无忧物流-标准',
    logistics_timeliness: '预计15-45天送达',
    warehouse_name: '申通国际-揽收仓',
  },
  {
    delivery_address:
      '河南省南阳市卧龙区百里奚街道 百里奚北路热电厂东隔墙永发酒店管理有限责任公司C座一楼8--12号',
    logistics_service_id: 'CAINIAO_STANDARD_TS_13477142',
    logistics_service_name: 'AliExpress 无忧物流-标准',
    logistics_timeliness: '预计15-45天送达',
    warehouse_name: '燕文南阳仓',
  },
  {
    delivery_address: '江苏省苏州市昆山市花桥镇 花集路668号宝湾物流1号库6号门',
    logistics_service_id: 'CAINIAO_STANDARD_TS_1710315',
    logistics_service_name: 'AliExpress 无忧物流-标准',
    logistics_timeliness: '预计15-45天送达',
    warehouse_name: '燕文上海仓-标准',
  },
  {
    delivery_address: '浙江省温州市龙湾区海滨街道 滨海园区3道4299号一号楼1楼',
    logistics_service_id: 'CAINIAO_STANDARD_TS_1710319',
    logistics_service_name: 'AliExpress 无忧物流-标准',
    logistics_timeliness: '预计15-45天送达',
    warehouse_name: '燕文温州仓-标准',
  },
  {
    delivery_address:
      '广东省东莞市沙田镇 东莞市沙田镇进港南路231号启盈后面菜鸟AE华南定制仓2号物流仓库一楼',
    logistics_service_id: 'CAINIAO_STANDARD_FPXGZ',
    logistics_service_name: 'AliExpress 无忧物流-标准',
    logistics_timeliness: '预计15-45天送达',
    warehouse_name: '递四方广州仓-标准',
  },
  {
    delivery_address:
      '福建省莆田市荔城区黄石镇 七境村林芝路189号双赢物流园基地11号楼1层东南侧（递四方速递无忧莆田仓）',
    logistics_service_id: 'CAINIAO_STANDARD_TS_13173082',
    logistics_service_name: 'AliExpress 无忧物流-标准',
    logistics_timeliness: '预计15-45天送达',
    warehouse_name: '递四方莆田仓-标准',
  },
  {
    delivery_address:
      '香港特别行政区新界元朗区 香港新界元朗流浮山廈村屏廈路DD129 Lot 3299 RP B倉(海暉重櫃場對面)',
    logistics_service_id: 'CAINIAO_STANDARD_FPXXG',
    logistics_service_name: 'AliExpress 无忧物流-标准',
    logistics_timeliness: '预计15-45天送达',
    warehouse_name: '递四方香港仓-标准',
  },
  {
    delivery_address:
      '广东省深圳市宝安区松岗街道 松岗大道1号2栋一楼（四方邮局）',
    logistics_service_id: 'CAINIAO_STANDARD_FPXSS',
    logistics_service_name: 'AliExpress 无忧物流-标准',
    logistics_timeliness: '预计15-45天送达',
    warehouse_name: '递四方深圳仓-标准',
  },
  {
    delivery_address: '山东省威海市文登区大水泊镇 广贸路14-2号，泓信公共仓',
    logistics_service_id: 'CAINIAO_STANDARD_30429442',
    logistics_service_name: 'AliExpress 无忧物流-标准',
    logistics_timeliness: '预计15-45天送达',
    warehouse_name: '递四方威海仓-揽收',
  },
  {
    delivery_address:
      '天津天津市东丽区东丽区开发区 天津市东丽区一经路信通路天津市永珍电子厂院内',
    logistics_service_id: 'CAINIAO_STANDARD_TS_13208965',
    logistics_service_name: 'AliExpress 无忧物流-标准',
    logistics_timeliness: '预计15-45天送达',
    warehouse_name: '燕文天津仓-标准',
  },
  {
    delivery_address:
      '广东省东莞市沙田镇 东莞市沙田镇进港南路231号启盈后面菜鸟AE华南定制仓2号物流仓库一楼',
    logistics_service_id: 'CAINIAO_STANDARD_FPXFS',
    logistics_service_name: 'AliExpress 无忧物流-标准',
    logistics_timeliness: '预计15-45天送达',
    warehouse_name: '递四方佛山仓-标准',
  },
  {
    delivery_address: '广东省中山市沙溪镇 涌头南康街49号1幢首层之2-7卡',
    logistics_service_id: 'CAINIAO_STANDARD_FPXZH',
    logistics_service_name: 'AliExpress 无忧物流-标准',
    logistics_timeliness: '预计15-45天送达',
    warehouse_name: '递四方珠海仓-标准',
  },
  {
    delivery_address:
      '福建省厦门市集美区灌口镇 航天路155-6号之一（原玉柴厂区6号厂房）内）',
    logistics_service_id: 'CAINIAO_STANDARD_FPXXM',
    logistics_service_name: 'AliExpress 无忧物流-标准',
    logistics_timeliness: '预计15-45天送达',
    warehouse_name: '递四方厦门仓-标准',
  },
  {
    delivery_address: '河北省保定市高碑店市白沟镇 CT机工业园合欢路32号东门',
    logistics_service_id: 'CAINIAO_STANDARD_TS_13171474',
    logistics_service_name: 'AliExpress 无忧物流-标准',
    logistics_timeliness: '预计15-45天送达',
    warehouse_name: '燕文保定仓-标准',
  },
  {
    delivery_address:
      '四川省成都市新都区新都镇 中集大道71号普洛斯新都物流园B3-204-5号门',
    logistics_service_id: 'CAINIAO_STANDARD_TS_13173894',
    logistics_service_name: 'AliExpress 无忧物流-标准',
    logistics_timeliness: '预计15-45天送达',
    warehouse_name: '燕文成都仓-标准',
  },
  {
    delivery_address:
      '广东省惠州市惠城区马安镇 惠州市惠城区马安镇新乐工业区4路第十小区D12号一层',
    logistics_service_id: 'CAINIAO_STANDARD_TS_13171478',
    logistics_service_name: 'AliExpress 无忧物流-标准',
    logistics_timeliness: '预计15-45天送达',
    warehouse_name: '递四方惠州仓-标准',
  },
];
export const premiumServices = [
  {
    delivery_address:
      '河南省郑州市其它区 九龙镇凤河东路普洛斯园区A-3库燕文物流',
    logistics_service_id: 'CAINIAO_PREMIUM_TS_12349475',
    logistics_service_name: 'AliExpress 无忧物流-优先',
    logistics_timeliness: '预计8-15天送达',
    warehouse_name: '燕文郑州仓-优先',
  },
  {
    delivery_address:
      '河南省南阳市卧龙区百里奚街道 百里奚北路热电厂东隔墙永发酒店管理有限责任公司C座一楼8--12号',
    logistics_service_id: 'CAINIAO_PREMIUM_TS_13477142',
    logistics_service_name: 'AliExpress 无忧物流-优先',
    logistics_timeliness: '预计8-15天送达',
    warehouse_name: '燕文南阳仓',
  },
  {
    delivery_address: '浙江省宁波市江北区洪塘街道 洪兴路6号',
    logistics_service_id: 'CAINIAO_PREMIUM_YANWENNB',
    logistics_service_name: 'AliExpress 无忧物流-优先',
    logistics_timeliness: '预计8-15天送达',
    warehouse_name: '燕文宁波仓-优先',
  },
  {
    delivery_address:
      '浙江省金华市义乌市稠江街道 龙海路825号普洛斯物流园A1-U4区',
    logistics_service_id: 'CAINIAO_PREMIUM_YANWENYW',
    logistics_service_name: 'AliExpress 无忧物流-优先',
    logistics_timeliness: '预计8-15天送达',
    warehouse_name: '燕文义乌仓-优先',
  },
  {
    delivery_address: '江苏省无锡市惠山区无锡惠山经济开发区 智慧路21号',
    logistics_service_id: 'CAINIAO_PREMIUM_TS_12712243',
    logistics_service_name: 'AliExpress 无忧物流-优先',
    logistics_timeliness: '预计8-15天送达',
    warehouse_name: '燕文无锡仓-优先',
  },
  {
    delivery_address:
      '福建省厦门市集美区灌口镇 航天路155-6号之一（原玉柴厂区6号厂房）内）',
    logistics_service_id: 'CAINIAO_PREMIUM_FPXXM',
    logistics_service_name: 'AliExpress 无忧物流-优先',
    logistics_timeliness: '预计8-15天送达',
    warehouse_name: '递四方厦门仓-优先',
  },
  {
    delivery_address: '江苏省苏州市昆山市花桥镇 花集路668号宝湾物流1号库6号门',
    logistics_service_id: 'CAINIAO_PREMIUM_YANWENSH',
    logistics_service_name: 'AliExpress 无忧物流-优先',
    logistics_timeliness: '预计8-15天送达',
    warehouse_name: '燕文上海仓-优先',
  },
  {
    delivery_address: '江苏省南京市江宁区秣陵街道 将军大道开拓路18号东一楼',
    logistics_service_id: 'CAINIAO_PREMIUM_YANWENNJ',
    logistics_service_name: 'AliExpress 无忧物流-优先',
    logistics_timeliness: '预计8-15天送达',
    warehouse_name: '燕文南京仓-优先',
  },
  {
    delivery_address: '浙江省杭州市萧山区萧山空港经济区 保税物流园8号仓',
    logistics_service_id: 'CAINIAO_PREMIUM_YANWENHZ',
    logistics_service_name: 'AliExpress 无忧物流-优先',
    logistics_timeliness: '预计8-15天送达',
    warehouse_name: '燕文杭州仓-优先',
  },
  {
    delivery_address: '浙江省温州市龙湾区海滨街道 滨海园区3道4299号一号楼1楼',
    logistics_service_id: 'CAINIAO_PREMIUM_YANWENWZ',
    logistics_service_name: 'AliExpress 无忧物流-优先',
    logistics_timeliness: '预计8-15天送达',
    warehouse_name: '燕文温州仓-优先',
  },
  {
    delivery_address:
      '广东省惠州市惠城区马安镇 惠州市惠城区马安镇新乐工业区4路第十小区D12号一层',
    logistics_service_id: 'CAINIAO_PREMIUM_TS_13174095',
    logistics_service_name: 'AliExpress 无忧物流-优先',
    logistics_timeliness: '预计8-15天送达',
    warehouse_name: '递四方惠州仓-优先',
  },
  {
    delivery_address:
      '上海上海市青浦区徐泾镇 （本地址不支持自寄或自送，下单时系统会自动匹配出最优交接仓地址，如杭州或者东莞出口口岸仓地址）',
    logistics_service_id: 'CAINIAO_PREMIUM_30140861',
    logistics_service_name: 'AliExpress 无忧物流-优先',
    logistics_timeliness: '预计8-15天送达',
    warehouse_name: '申通国际-揽收仓',
  },
  {
    delivery_address: '广东省汕头市金平区广厦街道 浮东路段蔡厝洋工业区26号',
    logistics_service_id: 'CAINIAO_PREMIUM_FPXST',
    logistics_service_name: 'AliExpress 无忧物流-优先',
    logistics_timeliness: '预计8-15天送达',
    warehouse_name: '递四方汕头仓-优先',
  },
  {
    delivery_address:
      '重庆重庆市九龙坡区石桥铺街道 二郎凯邦支路16号惠凌实业仓库大楼6楼14号',
    logistics_service_id: 'CAINIAO_PREMIUM_TS_13323632',
    logistics_service_name: 'AliExpress 无忧物流-优先',
    logistics_timeliness: '预计8-15天送达',
    warehouse_name: '燕文重庆仓-优先',
  },
  {
    delivery_address: '河北省保定市高碑店市白沟镇 CT机工业园合欢路32号东门',
    logistics_service_id: 'CAINIAO_PREMIUM_TS_13171473',
    logistics_service_name: 'AliExpress 无忧物流-优先',
    logistics_timeliness: '预计8-15天送达',
    warehouse_name: '燕文保定仓-优先',
  },
  {
    delivery_address:
      '四川省成都市新都区新都镇 中集大道71号普洛斯新都物流园B3-204-5号门',
    logistics_service_id: 'CAINIAO_PREMIUM_TS_13173893',
    logistics_service_name: 'AliExpress 无忧物流-优先',
    logistics_timeliness: '预计8-15天送达',
    warehouse_name: '燕文成都仓-优先',
  },
  {
    delivery_address: '辽宁省葫芦岛市兴城市宁远街道 铁道西21号',
    logistics_service_id: 'CAINIAO_PREMIUM_TS_13173896',
    logistics_service_name: 'AliExpress 无忧物流-优先',
    logistics_timeliness: '预计8-15天送达',
    warehouse_name: '燕文葫芦岛仓-优先',
  },
  {
    delivery_address: '广东省中山市沙溪镇 涌头南康街49号1幢首层之2-7卡',
    logistics_service_id: 'CAINIAO_PREMIUM_FPXZH',
    logistics_service_name: 'AliExpress 无忧物流-优先',
    logistics_timeliness: '预计8-15天送达',
    warehouse_name: '递四方珠海仓-优先',
  },
  {
    delivery_address:
      '广东省东莞市沙田镇 进港南路231号启盈后面菜鸟AE华南定制仓2号物流仓库一楼',
    logistics_service_id: 'CAINIAO_PREMIUM_FPXDG',
    logistics_service_name: 'AliExpress 无忧物流-优先',
    logistics_timeliness: '预计8-15天送达',
    warehouse_name: '递四方东莞仓-优先',
  },
  {
    delivery_address: '广东省中山市沙溪镇 涌头南康街49号1幢首层之2-7卡',
    logistics_service_id: 'CAINIAO_PREMIUM_FPXZS',
    logistics_service_name: 'AliExpress 无忧物流-优先',
    logistics_timeliness: '预计8-15天送达',
    warehouse_name: '递四方中山仓-优先',
  },
  {
    delivery_address:
      '福建省泉州市丰泽区东海街道 东海滨城通港东街533号（临江雕塑工艺厂内）',
    logistics_service_id: 'CAINIAO_PREMIUM_FPXQZ',
    logistics_service_name: 'AliExpress 无忧物流-优先',
    logistics_timeliness: '预计8-15天送达',
    warehouse_name: '递四方泉州仓-优先',
  },
  {
    delivery_address:
      '广东省深圳市宝安区松岗街道 松岗大道1号2栋一楼（四方邮局）',
    logistics_service_id: 'CAINIAO_PREMIUM_FPXSS',
    logistics_service_name: 'AliExpress 无忧物流-优先',
    logistics_timeliness: '预计8-15天送达',
    warehouse_name: '递四方深圳仓-优先',
  },
  {
    delivery_address:
      '广东省东莞市沙田镇 东莞市沙田镇进港南路231号启盈后面菜鸟AE华南定制仓2号物流仓库一楼',
    logistics_service_id: 'CAINIAO_PREMIUM_FPXGZ',
    logistics_service_name: 'AliExpress 无忧物流-优先',
    logistics_timeliness: '预计8-15天送达',
    warehouse_name: '递四方广州仓-优先',
  },
  {
    delivery_address:
      '福建省福州市仓山区盖山镇 白湖亭埔下路仓山科技园区 V-03号 兴福兴大厦综合楼北楼一层',
    logistics_service_id: 'CAINIAO_PREMIUM_FPXFZ',
    logistics_service_name: 'AliExpress 无忧物流-优先',
    logistics_timeliness: '预计8-15天送达',
    warehouse_name: '递四方福州仓-优先',
  },
  {
    delivery_address:
      '山东省青岛市李沧区虎山路街道 黑龙江中路398号中艺1688创意产业园D2座105-108',
    logistics_service_id: 'CAINIAO_PREMIUM_FPXQD',
    logistics_service_name: 'AliExpress 无忧物流-优先',
    logistics_timeliness: '预计8-15天送达',
    warehouse_name: '递四方青岛仓-优先',
  },
  {
    delivery_address:
      '广东省东莞市沙田镇 东莞市沙田镇进港南路231号启盈后面菜鸟AE华南定制仓2号物流仓库一楼',
    logistics_service_id: 'CAINIAO_PREMIUM_FPXFS',
    logistics_service_name: 'AliExpress 无忧物流-优先',
    logistics_timeliness: '预计8-15天送达',
    warehouse_name: '递四方佛山仓-优先',
  },
  {
    delivery_address:
      '福建省莆田市荔城区黄石镇 七境村林芝路189号双赢物流园基地11号楼1层东南侧（递四方速递无忧莆田仓）',
    logistics_service_id: 'CAINIAO_PREMIUM_TS_13173084',
    logistics_service_name: 'AliExpress 无忧物流-优先',
    logistics_timeliness: '预计8-15天送达',
    warehouse_name: '递四方莆田仓-优先',
  },
  {
    delivery_address:
      '河北省石家庄市裕华区裕翔街道 与贾商路交叉口北行100米路东',
    logistics_service_id: 'CAINIAO_PREMIUM_TS_13476647',
    logistics_service_name: 'AliExpress 无忧物流-优先',
    logistics_timeliness: '预计8-15天送达',
    warehouse_name: '燕文石家庄仓',
  },
  {
    delivery_address:
      '北京北京市顺义区南法信镇 顺畅大道16号的普洛斯北京空港物流园，位于项目的B4号库（物业）D区南侧单元，燕文物流',
    logistics_service_id: 'CAINIAO_PREMIUM_YANWENBJ',
    logistics_service_name: 'AliExpress 无忧物流-优先',
    logistics_timeliness: '预计8-15天送达',
    warehouse_name: '燕文北京仓-优先',
  },
  {
    delivery_address:
      '天津天津市东丽区东丽区开发区 天津市东丽区一经路信通路天津市永珍电子厂院内',
    logistics_service_id: 'CAINIAO_PREMIUM_TS_13207150',
    logistics_service_name: 'AliExpress 无忧物流-优先',
    logistics_timeliness: '预计8-15天送达',
    warehouse_name: '燕文天津仓-优先',
  },
  {
    delivery_address: '江苏省苏州市吴中区开发区 兴吴路58号',
    logistics_service_id: 'CAINIAO_PREMIUM_TS_12712442',
    logistics_service_name: 'AliExpress 无忧物流-优先',
    logistics_timeliness: '预计8-15天送达',
    warehouse_name: '燕文苏州仓-优先',
  },
  {
    delivery_address: '江西省南昌市南昌县昌东镇 创新三路199号  燕文物流',
    logistics_service_id: 'CAINIAO_PREMIUM_TS_13207149',
    logistics_service_name: 'AliExpress 无忧物流-优先',
    logistics_timeliness: '预计8-15天送达',
    warehouse_name: '燕文南昌仓-优先',
  },
  {
    delivery_address: '江苏省苏州市昆山市花桥镇 花集路668号宝湾物流1号库11号门',
    logistics_service_id: 'CAINIAO_PREMIUM_TS_13172664',
    logistics_service_name: 'AliExpress 无忧物流-优先',
    logistics_timeliness: '预计8-15天送达',
    warehouse_name: '燕文昆山仓-优先',
  },
  {
    delivery_address:
      '湖北省武汉市东西湖区径河街道 新城十三路中原物流园B\\/16-24号递四方速递',
    logistics_service_id: 'CAINIAO_PREMIUM_30500252',
    logistics_service_name: 'AliExpress 无忧物流-优先',
    logistics_timeliness: '预计8-15天送达',
    warehouse_name: '递四方武汉仓-揽收',
  },
  {
    delivery_address:
      '安徽省合肥市蜀山区蜀山新产业园区 仰桥路381号向东50米5号仓',
    logistics_service_id: 'CAINIAO_PREMIUM_TS_13208893',
    logistics_service_name: 'AliExpress 无忧物流-优先',
    logistics_timeliness: '预计8-15天送达',
    warehouse_name: '燕文合肥仓-优先',
  },
  {
    delivery_address:
      '湖南省长沙市天心区黑石铺街道 新开铺路960号院内递四方速递',
    logistics_service_id: 'CAINIAO_PREMIUM_TS_12720688',
    logistics_service_name: 'AliExpress 无忧物流-优先',
    logistics_timeliness: '预计8-15天送达',
    warehouse_name: '递四方长沙仓-优先',
  },
];

export const sellerShips = [
  {
    displayName: 'CN_OVERSEA_OD_RU',
    logisticsCompany: 'CN_OVERSEA_OD_RU',
    serviceName: 'CN_OVERSEA_OD_RU',
    trackingNoRegex: '^(AEOWH)[0-9]{10}(RU)[0-9]*$',
  },
  {
    displayName: '菜鸟俄罗斯官方配(省)',
    logisticsCompany: 'CN_OVERSEA_OD_RU_PROV',
    serviceName: 'CN_OVERSEA_OD_RU_PROV',
    trackingNoRegex:
      '^(AEOWH)[0-9]{10}(RU)[0-9]*$|^(AEWH)[0-9]{10}(RU)[0-9]*$|^(RL)[0-9]*$|^(9988)[0-9]*$|^(RL)[A-Z][0-9]*$',
  },
  {
    displayName: 'Posteitaliane',
    logisticsCompany: 'POSTEITALIANE',
    serviceName: 'POSTEITALIANE',
    trackingNoRegex: '(^[a-zA-Z0-9]{11,13}$)',
  },
  {
    displayName: 'LAPOSTE',
    logisticsCompany: 'LAPOSTE',
    serviceName: 'LAPOSTE',
    trackingNoRegex: '(^[a-zA-Z0-9]{11,13}$)',
  },
  {
    displayName: 'Deutsche Post',
    logisticsCompany: 'DEUTSCHE_POST',
    serviceName: 'DEUTSCHE_POST',
    trackingNoRegex: '(^[a-zA-Z0-9]{11,13}$)',
  },
  {
    displayName: 'USPS',
    logisticsCompany: 'USPS',
    serviceName: 'USPS',
    trackingNoRegex: '(^[a-zA-Z0-9]{1,34}$)',
  },
  {
    displayName: 'Russian Post',
    logisticsCompany: 'RUSSIAN_POST',
    serviceName: 'RUSSIAN_POST',
    trackingNoRegex: '(^[a-zA-Z0-9]{11,14}$)',
  },
  {
    displayName: 'Correos',
    logisticsCompany: 'CORREOS',
    serviceName: 'CORREOS',
    trackingNoRegex: '(^[a-zA-Z0-9]{11,13}$|^[a-zA-Z0-9]{23}$)',
  },
  {
    displayName: 'CLPOST',
    logisticsCompany: 'CLPOST',
    serviceName: 'CLPOST',
    trackingNoRegex: '(^[0-9]{26}$)',
  },
  {
    displayName: 'UPS',
    logisticsCompany: 'UPS',
    serviceName: 'UPS_US',
    trackingNoRegex: '(^[a-zA-Z0-9]{11}$)|(^[a-zA-Z0-9]{18}$)',
  },
  {
    displayName: 'Royal Mail',
    logisticsCompany: 'ROYAL_MAIL',
    serviceName: 'ROYAL_MAIL',
    trackingNoRegex: '(^[a-zA-Z0-9]{11,13}$)',
  },
  {
    displayName: 'AUSPOST',
    logisticsCompany: 'AUSPOST',
    serviceName: 'AUSPOST',
    trackingNoRegex: '(^[a-zA-Z0-9]{11,13}$)|(^[a-zA-Z]{3}[0-9]{13}$)',
  },
  {
    displayName: 'Asendia',
    logisticsCompany: 'Asendia',
    serviceName: 'ASENDIA_US',
    trackingNoRegex: '(^UJ[0-9]{9}US$|^A0000[0-9]{8}$)',
  },
  {
    displayName: 'JNE',
    logisticsCompany: 'JNE',
    serviceName: 'JNE',
    trackingNoRegex: '(^[a-zA-Z0-9]{1,66}$)',
  },
  {
    displayName: 'aCommerce',
    logisticsCompany: 'ACOMMERCE',
    serviceName: 'ACOMMERCE',
    trackingNoRegex: '(^[a-zA-Z0-9]{1,66}$)',
  },
  {
    displayName: 'DHL_FR',
    logisticsCompany: 'DHL',
    serviceName: 'DHL_FR',
    trackingNoRegex: '^([a-zA-Z0-9]|[_-]){1,32}$',
  },
  {
    displayName: 'DHL_IT',
    logisticsCompany: 'DHL',
    serviceName: 'DHL_IT',
    trackingNoRegex: '^[0-9]{10}$',
  },
  {
    displayName: 'DHL_UK',
    logisticsCompany: 'DHL',
    serviceName: 'DHL_UK',
    trackingNoRegex: '^[0-9]{10}$',
  },
  {
    displayName: 'DHL_DE',
    logisticsCompany: 'DHL',
    serviceName: 'DHL_DE',
    trackingNoRegex: '^([a-zA-Z0-9]|[_-]){1,32}$',
  },
  {
    displayName: "Seller's Shipping Method - IL",
    logisticsCompany: 'OTHER_IL',
    serviceName: 'Other_IL',
    trackingNoRegex: '(^[a-zA-Z0-9]{0,30}$)',
  },
  {
    displayName: 'DHL_ES',
    logisticsCompany: 'DHL',
    serviceName: 'DHL_ES',
    trackingNoRegex: '^[a-zA-Z0-9]{1,30}$',
  },
  {
    displayName: 'Chronopost',
    logisticsCompany: 'CHRONOPOST_FR',
    serviceName: 'CHRONOPOST_FR',
    trackingNoRegex: '^[A-Z]{2}[0-9]{9}FR$',
  },
  {
    displayName: 'OTHER GH',
    logisticsCompany: 'OTHER_GH',
    serviceName: 'OTHER_GH',
    trackingNoRegex: '(^[a-zA-Z0-9]{1,60}$)',
  },
  {
    displayName: 'SEUR',
    logisticsCompany: 'SEUR',
    serviceName: 'SEUR',
    trackingNoRegex: '^([a-zA-Z0-9]|[_-]){1,32}$',
  },
  {
    displayName: 'POST KR Oversea',
    logisticsCompany: 'POST_KR_Oversea',
    serviceName: 'POST_KR_Oversea',
    trackingNoRegex: '(^[a-zA-Z]{2}[0-9]{9}KR$)',
  },
  {
    displayName: 'JNET_IL',
    logisticsCompany: 'JNET_IL',
    serviceName: 'JNET_IL',
    trackingNoRegex: '(^JNTCU[0-9]{10}YQ$)',
  },
  {
    displayName: 'DPD_DE',
    logisticsCompany: 'DPD_DE',
    serviceName: 'DPD_DE',
    trackingNoRegex: '^[0-9]{14}$',
  },
  {
    displayName: 'Nova_Poshta',
    logisticsCompany: 'NOVA_POSHTA',
    serviceName: 'NOVA_POSHTA',
    trackingNoRegex: '(^[A-Za-z0-9]{14}$)',
  },
  {
    displayName: 'DPEX_ZA',
    logisticsCompany: 'DPEX_ZA',
    serviceName: 'DPEX_ZA',
    trackingNoRegex: '(^[a-zA-Z0-9]{6,64}$)',
  },
  {
    displayName: 'UPS_DE',
    logisticsCompany: 'UPS_DE',
    serviceName: 'UPS_DE',
    trackingNoRegex: '^[a-zA-Z0-9]{10,32}$',
  },
  {
    displayName: 'InPost',
    logisticsCompany: 'INPOST_PL',
    serviceName: 'INPOST_PL',
    trackingNoRegex: '^[0-9]{24}$',
  },
  {
    displayName: 'UPS_ES',
    logisticsCompany: 'UPS_ES',
    serviceName: 'UPS_ES',
    trackingNoRegex: '^[a-zA-Z0-9]{0,32}$',
  },
  {
    displayName: 'AliExpress Premium Shipping',
    logisticsCompany: 'CAINIAO_PREMIUM',
    serviceName: 'CAINIAO_PREMIUM',
    trackingNoRegex: '(^[a-zA-z0-9]{1,32}$)',
  },
  {
    displayName: 'Singapore Post_VN',
    logisticsCompany: 'SGP_VN',
    serviceName: 'SGP_VN',
    trackingNoRegex: '(^RX[0-9]{9}SG$)',
  },
  {
    displayName: 'CN_JNET_EXPRESS_RU',
    logisticsCompany: 'JNET_OVERSEA_RU',
    serviceName: 'JNET_OVERSEA_RU',
    trackingNoRegex: '(^JNTCU[0-9]{10}YQ$)',
  },
  {
    displayName: 'Cainiao Heavy Parcel Line',
    logisticsCompany: 'CAINIAO_STANDARD_HEAVY',
    serviceName: 'CAINIAO_STANDARD_HEAVY',
    trackingNoRegex: '^AECA[a-zA-Z0-9]{13}$',
  },
  {
    displayName: 'FEDEX',
    logisticsCompany: 'FEDEX',
    serviceName: 'FEDEX_US',
    trackingNoRegex: '(^[a-zA-Z0-9]{0,32}$)',
  },
  {
    displayName: "Seller's Shipping Method - CZ",
    logisticsCompany: 'OTHER_CZ',
    serviceName: 'OTHER_CZ',
    trackingNoRegex: '(^[a-zA-Z0-9]{0,30}$)',
  },
  {
    displayName: 'Ukrposhta',
    logisticsCompany: 'UKRPOSHTA',
    serviceName: 'UKRPOSHTA',
    trackingNoRegex: '(^65[A-Za-z0-9]{11}$)|(^05[A-Za-z0-9]{11}$)',
  },
  {
    displayName: 'Poland Post',
    logisticsCompany: 'POLANDPOST_PL',
    serviceName: 'POLANDPOST_PL',
    trackingNoRegex: '(^[A-Z]{1}[0-9]{10}PL$)|(^[0-9]{20}$)',
  },
  {
    displayName: 'BE_POST_BE',
    logisticsCompany: 'BE_POST_BE',
    serviceName: 'BE_POST_BE',
    trackingNoRegex: '^[a-zA-Z0-9]{5,32}$',
  },
  {
    displayName: 'DGM_US_SMALL',
    logisticsCompany: 'DGM_US_SMALL',
    serviceName: 'DGM_US_SMALL',
    trackingNoRegex: '^([a-zA-Z0-9]|[_-]){1,32}$',
  },
  {
    displayName: 'UPS_BE',
    logisticsCompany: 'UPS_BE',
    serviceName: 'UPS_BE',
    trackingNoRegex: '^[a-zA-Z0-9]{5,32}$',
  },
  {
    displayName: 'Cainiao Expedited Standard',
    logisticsCompany: 'AE_CAINIAO_STANDARD',
    serviceName: 'AE_CAINIAO_STANDARD',
    trackingNoRegex: '(^[a-zA-z0-9]{1,34}$)',
  },
  {
    displayName: 'COLISSIMO_BE',
    logisticsCompany: 'COLISSIMO_BE',
    serviceName: 'COLISSIMO_BE',
    trackingNoRegex: '^[a-zA-Z0-9]{2}[0-9]{11}$',
  },
  {
    displayName: 'DHL_PL',
    logisticsCompany: 'DHL_PL',
    serviceName: 'DHL_PL',
    trackingNoRegex: '^([a-zA-Z0-9]|[_-]){1,32}$',
  },
  {
    displayName: 'Exelot Express',
    logisticsCompany: 'EXELOT_IL',
    serviceName: 'EXELOT_IL',
    trackingNoRegex: '(^XLT[0-9]{9}$)',
  },
  {
    displayName: '360Lion Standard Packet',
    logisticsCompany: '360Lion',
    serviceName: 'AE_360LION_STANDARD',
    trackingNoRegex: '^WSH[A-Z]{2}[0-9]{10}YQ',
  },
  {
    displayName: 'SMSA_SA',
    logisticsCompany: 'SMSA_SA',
    serviceName: 'SMSA_SA',
    trackingNoRegex: '(^[0-9]{12}$)',
  },
  {
    displayName: 'DPD_ES',
    logisticsCompany: 'DPD',
    serviceName: 'DPD_ES',
    trackingNoRegex: '(^[a-zA-Z0-9]{6,64}$)',
  },
  {
    displayName: 'NAQEL',
    logisticsCompany: 'NAQEL_SA',
    serviceName: 'NAQEL_SA',
    trackingNoRegex: '(^[0-9]{8}$)',
  },
  {
    displayName: 'Correos Express',
    logisticsCompany: 'Correos Express',
    serviceName: 'CORREOSEXPRESS',
    trackingNoRegex: '^([a-zA-Z0-9]|[_-]){1,32}$',
  },
  {
    displayName: 'ESNAD',
    logisticsCompany: 'ESNAD_SA',
    serviceName: 'ESNAD_SA',
    trackingNoRegex: '(^[0-9]{14}$)|(^[0-9]{17}$)',
  },
  {
    displayName: 'OTHER NG',
    logisticsCompany: 'OTHER_NG',
    serviceName: 'OTHER_NG',
    trackingNoRegex: '^([a-zA-Z0-9]|[_-]){1,32}$',
  },
  {
    displayName: 'OTHER KE',
    logisticsCompany: 'OTHER_KE',
    serviceName: 'OTHER_KE',
    trackingNoRegex: '(^[a-zA-Z0-9]{1,60}$)',
  },
  {
    displayName: 'CSE',
    logisticsCompany: 'CSE',
    serviceName: 'CSE',
    trackingNoRegex: 'JNTCU[0-9]{10}YQ',
  },
  {
    displayName: 'ARAS',
    logisticsCompany: 'ARAS_TR',
    serviceName: 'ARAS_TR',
    trackingNoRegex: '^[0-9]{13}$',
  },
  {
    displayName: 'ARAMEX',
    logisticsCompany: 'ARAMEX_SA',
    serviceName: 'ARAMEX_SA',
    trackingNoRegex: '(^[0-9]{11}$)',
  },
  {
    displayName: 'OTHER ZA',
    logisticsCompany: 'OTHER_ZA',
    serviceName: 'OTHER_ZA',
    trackingNoRegex: '^([a-zA-Z0-9]|[_-]){1,32}$',
  },
  {
    displayName: 'EMS_AE',
    logisticsCompany: 'EMS_AE',
    serviceName: 'EMS_AE',
    trackingNoRegex: '(^E[a-zA-z]{1}[0-9]{9}AE$)',
  },
  {
    displayName: 'UPS_CZ_EU',
    logisticsCompany: 'UPS_CZ_EU',
    serviceName: 'UPS_CZ_EU',
    trackingNoRegex: '^([a-zA-Z0-9]|[_-]){1,32}$',
  },
  {
    displayName: 'YODEL',
    logisticsCompany: 'YODEL_UK',
    serviceName: 'YODEL_UK',
    trackingNoRegex: '^[a-zA-Z0-9]{5,32}$',
  },
  {
    displayName: 'GLS_ES_ASM',
    logisticsCompany: 'ASM',
    serviceName: 'ASM',
    trackingNoRegex: '(^[a-zA-Z0-9]{3,18}$)',
  },
  {
    displayName: 'FETCHR',
    logisticsCompany: 'FETCHR_SA',
    serviceName: 'FETCHR_SA',
    trackingNoRegex: '(^[0-9]{14}$)',
  },
  {
    displayName: 'Cainiao Expedited Economy',
    logisticsCompany: 'CAINIAONNRM',
    serviceName: 'CAINIAO_EXPEDITED_ECONOMY',
    trackingNoRegex:
      '(^[A-Za-z0-9]{18}$|^UB[0-9]{9}LV$|^PCLP[0-9]{19}$|^N[0-9]{13}$)',
  },
  {
    displayName: 'CJ Oversea',
    logisticsCompany: 'CJ_KR_Oversea',
    serviceName: 'CJ_KR_Oversea',
    trackingNoRegex: '(^[0-9]{12}$)',
  },
  {
    displayName: 'GLS_PL',
    logisticsCompany: 'GLS',
    serviceName: 'GLS_PL',
    trackingNoRegex: '^([a-zA-Z0-9]|[_-]){1,32}$',
  },
  {
    displayName: 'HERMES_UK',
    logisticsCompany: 'HERMES_UK',
    serviceName: 'HERMES_UK',
    trackingNoRegex: '^([a-zA-Z0-9]|[_-]){1,32}$',
  },
  {
    displayName: 'CN_RUE_EXPRESS_RU',
    logisticsCompany: 'RUE_OVERSEA_RU',
    serviceName: 'RUE_OVERSEA_RU',
    trackingNoRegex:
      '(^11[0-9]{8}$)|(^140[0-9]{11}$)|(^RUEZC[0-9]{10}YQ$)|(^RUEZD[0-9]{10}YQ$)|(^RUEZP[0-9]{10}YQ$)|(^RUEZX[0-9]{10}YQ$)',
  },
  {
    displayName: 'Colissimo',
    logisticsCompany: 'COLISSIMO_FR',
    serviceName: 'COLISSIMO_FR',
    trackingNoRegex: '^[a-zA-Z0-9]{2}[0-9]{11}',
  },
  {
    displayName: 'Colis_Prive',
    logisticsCompany: 'COLIS_PRIVE',
    serviceName: 'COLIS_PRIVE',
    trackingNoRegex: '^([a-zA-Z0-9]|[_-]){1,32}$',
  },
  {
    displayName: 'Post LV',
    logisticsCompany: 'POST_LV',
    serviceName: 'POST_LV',
    trackingNoRegex: '(^[a-zA-Z]{2}[0-9]{9}[a-zA-Z]{2}$)',
  },
  {
    displayName: 'GLS_ES',
    logisticsCompany: 'GLS_ES',
    serviceName: 'GLS_ES',
    trackingNoRegex: '^([a-zA-Z0-9]|[_-]){1,32}$',
  },
  {
    displayName: 'Turkey Post',
    logisticsCompany: 'PTT_TR',
    serviceName: 'PTT_TR',
    trackingNoRegex: '(^[a-zA-Z]{2}[0-9]{9}TR$)',
  },
  {
    displayName: 'UPS_PL',
    logisticsCompany: 'UPS_PL',
    serviceName: 'UPS_PL',
    trackingNoRegex: '^([a-zA-Z0-9]|[_-]){1,32}$',
  },
  {
    displayName: 'GLS_DE',
    logisticsCompany: 'GLS_DE',
    serviceName: 'GLS_DE',
    trackingNoRegex: '^[a-zA-Z0-9]{5,20}$',
  },
  {
    displayName: 'GLS',
    logisticsCompany: 'GLS_CZ',
    serviceName: 'GLS_CZ',
    trackingNoRegex: '^[0-9]{12}$',
  },
  {
    displayName: 'DE_POST_CZ',
    logisticsCompany: 'DE_POST_CZ',
    serviceName: 'DE_POST_CZ',
    trackingNoRegex: '^[a-zA-Z0-9]{5,32}$',
  },
  {
    displayName: 'MRW',
    logisticsCompany: 'MRW',
    serviceName: 'MRW',
    trackingNoRegex: '^[0-9]{12}$',
  },
  {
    displayName: 'GLS_BE',
    logisticsCompany: 'GLS_BE',
    serviceName: 'GLS_BE',
    trackingNoRegex: '^[a-zA-Z0-9]{5,20}$',
  },
  {
    displayName: 'DHL Europe',
    logisticsCompany: 'SPAIN_OVERSEAS_DHL',
    serviceName: 'SPAIN_OVERSEAS_DHL',
    trackingNoRegex: '^([a-zA-Z0-9]|[_-]){1,32}$',
  },
  {
    displayName: 'DE_POST_BE',
    logisticsCompany: 'DE_POST_BE',
    serviceName: 'DE_POST_BE',
    trackingNoRegex: '^[a-zA-Z0-9]{5,32}$',
  },
  {
    displayName: 'DHL_BE',
    logisticsCompany: 'DHL_BE',
    serviceName: 'DHL_BE',
    trackingNoRegex: '^[a-zA-Z0-9]{5,32}$',
  },
  {
    displayName: 'Hungary Post',
    logisticsCompany: 'HUNGARY_POST',
    serviceName: 'HUNGARY_POST',
    trackingNoRegex: '(^[a-zA-z]{2}[0-9]{9}HU$)',
  },
  {
    displayName: 'CHOICE',
    logisticsCompany: 'CHOICE',
    serviceName: 'CHOICE',
    trackingNoRegex: '(^[A-Za-z]{1}[0-9]{5}[A-Za-z]{2}[0-9]{6}$)',
  },
  {
    displayName: 'Correios',
    logisticsCompany: 'CORREIOS_L_BR',
    serviceName: 'CORREIOS_L_BR',
    trackingNoRegex: '(^[a-zA-Z]{2}[0-9]{9}BR$)',
  },
  {
    displayName: 'GLS_FR',
    logisticsCompany: 'GLS_FR',
    serviceName: 'GLS_FR',
    trackingNoRegex: '^([a-zA-Z0-9]|[_-]){1,32}$',
  },
  {
    displayName: 'DHL_CZ',
    logisticsCompany: 'DHL_CZ',
    serviceName: 'DHL_CZ',
    trackingNoRegex: '^([a-zA-Z0-9]|[_-]){1,32}$',
  },
  {
    displayName: 'AliExpress Standard Shipping',
    logisticsCompany: 'CAINIAO_STANDARD',
    serviceName: 'CAINIAO_STANDARD',
    trackingNoRegex: '(^[a-zA-z0-9]{1,34}$)',
  },
  {
    displayName: 'Cainiao Standard For Special Goods',
    logisticsCompany: 'CAINIAO_STANDARD_SG',
    serviceName: 'CAINIAO_STANDARD_SG',
    trackingNoRegex: '(^[a-zA-Z0-9]{1,36}$)',
  },
  {
    displayName: 'POSTNET_ZA',
    logisticsCompany: 'POSTNET_ZA',
    serviceName: 'POSTNET_ZA',
    trackingNoRegex: '(^[a-zA-Z0-9]{6,64}$)',
  },
  {
    displayName: 'Cainiao Faster Delivery',
    logisticsCompany: 'AE_4PL_STANDARD_CFD_AE',
    serviceName: 'AE_4PL_STANDARD_CFD_AE',
    trackingNoRegex: '(^[a-zA-z0-9]{1,34}$)',
  },
  {
    displayName: 'UPS_NG',
    logisticsCompany: 'UPS_NG',
    serviceName: 'UPS_NG',
    trackingNoRegex: '(^[a-zA-Z0-9]{6,64}$)',
  },
  {
    displayName: 'DPD_PL',
    logisticsCompany: 'DPD_PL',
    serviceName: 'DPD_PL',
    trackingNoRegex: '(^[a-zA-Z0-9]{6,64}$)',
  },
  {
    displayName: 'OTHER PL',
    logisticsCompany: 'OTHER_PL',
    serviceName: 'OTHER_PL',
    trackingNoRegex: '^([a-zA-Z0-9]|[_-]){1,32}$',
  },
  {
    displayName: 'CITITRANS_AE',
    logisticsCompany: 'CITITRANS_AE',
    serviceName: 'CITITRANS_AE',
    trackingNoRegex: '(^YBE[a-zA-Z]{2}[0-9]{10}YQ$)',
  },
  {
    displayName: 'VNLIN_SA',
    logisticsCompany: 'VNLIN_SA',
    serviceName: 'VNLIN_SA',
    trackingNoRegex: '(^CNB[0-9]{7}$)',
  },
  {
    displayName: 'IMILE_SA',
    logisticsCompany: 'IMILE_SA',
    serviceName: 'IMILE_SA',
    trackingNoRegex: '(^6[0-9]{12}$)',
  },
  {
    displayName: 'SPSR_RU',
    logisticsCompany: 'SPSR_RU',
    serviceName: 'SPSR_RU',
    trackingNoRegex: '(^[0-9]{9}$|^[a-zA-Z0-9]{17}$|^[a-zA-Z0-9]{9,12}$)',
  },
  {
    displayName: 'Aliexpress Direct',
    logisticsCompany: 'CAINIAO_CONSOLIDATION_SA',
    serviceName: 'CAINIAO_CONSOLIDATION_SA',
    trackingNoRegex: '(^[a-zA-Z0-9]{1,64}$)',
  },
  {
    displayName: 'Aliexpress Direct',
    logisticsCompany: 'CAINIAO_CONSOLIDATION_AE',
    serviceName: 'CAINIAO_CONSOLIDATION_AE',
    trackingNoRegex: '(^[a-zA-Z0-9]{1,64}$)',
  },
  {
    displayName: 'Aliexpress Direct',
    logisticsCompany: 'CAINIAO_CONSOLIDATION_BR',
    serviceName: 'CAINIAO_CONSOLIDATION_BR',
    trackingNoRegex: '(^[a-zA-Z0-9]{1,64}$)',
  },
  {
    displayName: 'VALIN_AE',
    logisticsCompany: 'VALIN_AE',
    serviceName: 'VALIN_AE',
    trackingNoRegex: '(^CNB[0-9]{7}$)',
  },
  {
    displayName: 'GES Express',
    logisticsCompany: 'GES',
    serviceName: 'GES',
    trackingNoRegex: '^ZCE[A-Za-z]{2}[0-9]{10}[A-Za-z]{2}$',
  },
  {
    displayName: 'CKE Express',
    logisticsCompany: 'CKE',
    serviceName: 'CKE',
    trackingNoRegex: '^CGE[A-Za-z]{2}[0-9]{10}[A-Za-z]{2}$',
  },
  {
    displayName: 'JCEX Express',
    logisticsCompany: 'JCEX',
    serviceName: 'JCEX',
    trackingNoRegex: '(^[A-Za-z]{3}[0-9]{10}[A-Za-z]{2}$)',
  },
  {
    displayName: 'SPRING RETURN  IT',
    logisticsCompany: 'SPRING_IT_RT',
    serviceName: 'SPRING_IT_RT',
    trackingNoRegex: '^([0-9]{1,32}$)',
  },
  {
    displayName: 'Cainiao Super Economy',
    logisticsCompany: 'CAINIAO_SUPER_ECONOMY',
    serviceName: 'CAINIAO_SUPER_ECONOMY',
    trackingNoRegex:
      '(^[A-Za-z0-9]{13}$)|(^LVS[0-9]{17}|(^[A-Za-z]{2}[0-9]{9}[A-Za-z]{2})$)|(^[a-zA-Z]{2}[0-9]{12}$)|(^[0-9]{20}$)',
  },
  {
    displayName: 'Cainiao Super Economy for Special Goods',
    logisticsCompany: 'CAINIAO_SUPER_ECONOMY_SG',
    serviceName: 'CAINIAO_SUPER_ECONOMY_SG',
    trackingNoRegex:
      '(^[A-Za-z0-9]{13}$)|(^LVS[0-9]{16}$)|(^[a-zA-z]{2}[0-9]{14}$)|(^[a-zA-z]{2}[0-9]{12}$)',
  },
  {
    displayName: 'China Post Ordinary Small Packet Plus',
    logisticsCompany: 'YANWEN',
    serviceName: 'YANWEN_JYT',
    trackingNoRegex: '(^[A-Za-z0-9]{11}[a-zA-z]{2}$)|(^[0-9]{11}$)',
  },
  {
    displayName: 'Yanwen Economic Air Mail',
    logisticsCompany: 'YANWEN',
    serviceName: 'YANWEN_ECONOMY',
    trackingNoRegex: '(^[a-zA-z]{1,2}[0-9]{14}$)',
  },
  {
    displayName: 'SunYou Economic Air Mail',
    logisticsCompany: 'SUNYOU',
    serviceName: 'SUNYOU_ECONOMY',
    trackingNoRegex: '(^[a-zA-z]{2}[0-9]{14}$)',
  },
  {
    displayName: 'Cainiao Saver Shipping For Special Goods',
    logisticsCompany: 'CAINIAO_ECONOMY_SG',
    serviceName: 'CAINIAO_ECONOMY_SG',
    trackingNoRegex: '(^[A-Za-z0-9]{13}$)',
  },
  {
    displayName: 'AliExpress Saver Shipping',
    logisticsCompany: 'CAINIAO_ECONOMY',
    serviceName: 'CAINIAO_ECONOMY',
    trackingNoRegex:
      '(^ZA[0-9]{9}[a-zA-Z0-9]{2}$)|(^[a-zA-Z0-9]{23}$)|(^[a-zA-Z]{2}[0-9]{9}EE$)|(^[a-zA-Z0-9]{26}$)|(^[a-zA-Z0-9]{13}$)|(^[a-zA-Z0-9]{21}$)|(^[a-zA-Z0-9]{14}$)',
  },
  {
    displayName: 'ePacket',
    logisticsCompany: 'EMS',
    serviceName: 'EMS_ZX_ZX_US',
    trackingNoRegex: '(^L[A-Za-z]{1}[0-9]{9}CN$)',
  },
  {
    displayName: 'China Post Registered Air Mail',
    logisticsCompany: 'CPAM',
    serviceName: 'CPAM',
    trackingNoRegex: '(^[a-zA-z]{2}[A-Za-z0-9]{9}[a-zA-z]{2}$)',
  },
  {
    displayName: 'China Post Air Parcel',
    logisticsCompany: 'CPAP',
    serviceName: 'CPAP',
    trackingNoRegex: '(^C[A-Za-z]{1}[0-9]{9}CN$)',
  },
  {
    displayName: 'Singapore Post',
    logisticsCompany: 'SGP',
    serviceName: 'SGP',
    trackingNoRegex: '(^[a-zA-Z0-9]{1,64}$)',
  },
  {
    displayName: 'DHL e-commerce',
    logisticsCompany: 'DHL',
    serviceName: 'DHLECOM',
    trackingNoRegex:
      '(^[a-zA-Z]{5}[a-zA-Z0-9]{6,20}$)|(^[a-zA-Z]{2}[0-9]{9}[a-zA-Z]{2}$)',
  },
  {
    displayName: 'Flyt Special Economy',
    logisticsCompany: 'FLYT_ECONOMY',
    serviceName: 'FLYT_ECONOMY_SG',
    trackingNoRegex: '(^FT[0-9]{10}S1BZ$)',
  },
  {
    displayName: 'TOPYOU Special Economy',
    logisticsCompany: 'TOPYOU_ECONOMY_SG',
    serviceName: 'TOPYOU_ECONOMY_SG',
    trackingNoRegex: '(^TYZPH[0-9]{10}YQ$)',
  },
  {
    displayName: 'BSC Special Economy',
    logisticsCompany: 'BSC_ECONOMY_SG',
    serviceName: 'BSC_ECONOMY_SG',
    trackingNoRegex: '(^UD[0-9]{9}NL$)|(^BSCPY[0-9]{10}YQ$)',
  },
  {
    displayName: 'YANWEN Special Standard',
    logisticsCompany: 'YANWEN_STANDARD_SG',
    serviceName: 'YANWEN_STANDARD_SG',
    trackingNoRegex: '(^VR[0-9]{9}YP$)|(YW[0-9]{2}T[0-9]{13}$)',
  },
  {
    displayName: 'YANWEN Special Economy',
    logisticsCompany: 'YANWEN_ECONOMY_SG',
    serviceName: 'YANWEN_ECONOMY_SG',
    trackingNoRegex: '(^UD[0-9]{9}YP$)|(YW[0-9]{2}T[0-9]{14}$)',
  },
  {
    displayName: 'TOPYOU',
    logisticsCompany: 'LAOPOST',
    serviceName: 'LAOPOST',
    trackingNoRegex: '(^TYZRB[0-9]{10}YQ$)',
  },
  {
    displayName: 'BSC Special Standard',
    logisticsCompany: 'BSC_STANDARD_SG',
    serviceName: 'BSC_STANDARD_SG',
    trackingNoRegex: '(^(RU|LT)[0-9]{9}NL$)|(^[0-9]{10}$)|(^BSCGH[0-9]{10}YQ$)',
  },
  {
    displayName: 'SunYou Special Economy',
    logisticsCompany: 'SUNYOU_ECONOMY_SG',
    serviceName: 'SUNYOU_ECONOMY_SG',
    trackingNoRegex: '(^SYAE[A-Z]{1}[0-9]{8}$)',
  },
  {
    displayName: 'CDEK_RU',
    logisticsCompany: 'CDEK_RU',
    serviceName: 'CDEK_RU',
    trackingNoRegex: '(^[a-zA-Z]{5}[0-9]{10}[a-zA-Z]{2}$)|(^[0-9]{10}$)',
  },
  {
    displayName: 'CNE Express',
    logisticsCompany: 'CNE',
    serviceName: 'CNE',
    trackingNoRegex: '(^[a-zA-Z0-9]{1,30}$)',
  },
  {
    displayName: 'DPD',
    logisticsCompany: 'DPD',
    serviceName: 'DPD',
    trackingNoRegex: '(^[a-zA-Z0-9]{1,30}$)',
  },
  {
    displayName: 'Flyt Express',
    logisticsCompany: 'FLYT',
    serviceName: 'FLYT',
    trackingNoRegex: '(^FT[0-9]{10}S2C0$)',
  },
  {
    displayName: 'IML Express',
    logisticsCompany: 'IML',
    serviceName: 'IML',
    trackingNoRegex: '(^[0-9]{13}$)',
  },
  {
    displayName: 'Meest',
    logisticsCompany: 'MIUSON',
    serviceName: 'MEEST',
    trackingNoRegex:
      '^[A-Za-z0-9]{2}[0-9]{7}[A-Za-z0-9]{2}[0-9]{5}[A-Za-z0-9]{1}$',
  },
  {
    displayName: 'PONY',
    logisticsCompany: 'PONY',
    serviceName: 'PONY',
    trackingNoRegex: '^PY[0-9]{5}[A-Za-z0-9]{2}[0-9]{6}CN$',
  },
  {
    displayName: 'PONY_RU',
    logisticsCompany: 'PONY_RU',
    serviceName: 'PONY_RU',
    trackingNoRegex: '(^[a-zA-Z0-9]{1,30}$)',
  },
  {
    displayName: 'UBI',
    logisticsCompany: 'UBI',
    serviceName: 'UBI',
    trackingNoRegex: '(^[a-zA-Z0-9]{1,30}$)',
  },
  {
    displayName: '4PX RM',
    logisticsCompany: '4PX',
    serviceName: 'FOURPX_RM',
    trackingNoRegex: '(^[0-9]{10,15}$)',
  },
  {
    displayName: 'SunYou',
    logisticsCompany: 'SUNYOU',
    serviceName: 'SUNYOU_RM',
    trackingNoRegex:
      '(^[a-zA-Z]{2}[a-zA-Z0-9]{3}[0-9]{8}$)|(^[a-zA-Z]{2}[0-9]{9}[a-zA-Z]{2}$)',
  },
  {
    displayName: 'Special Line-YW',
    logisticsCompany: 'YANWEN',
    serviceName: 'YANWEN_AM',
    trackingNoRegex:
      '(^[a-zA-z]{2}[A-Za-z0-9]{9}[a-zA-z]{2}$)|(^[a-zA-z]{1,2}[0-9]{14}$)',
  },
  {
    displayName: 'SF eParcel',
    logisticsCompany: 'SF_EPARCEL',
    serviceName: 'SF_EPARCEL',
    trackingNoRegex:
      '^[0-9]{12}$|^[a-zA-Z]{2}[0-9]{9}[a-zA-Z]{2}$|(^SF[0-9]{13}$)',
  },
  {
    displayName: 'Aramex',
    logisticsCompany: 'ARAMEX',
    serviceName: 'ARAMEX',
    trackingNoRegex: '(^[0-9]{10,12}$)',
  },
  {
    displayName: '139EXPRESS',
    logisticsCompany: 'ECONOMIC139',
    serviceName: 'ECONOMIC139',
    trackingNoRegex: '^OTN[A-Z]{2}[0-9]{10}YQ$',
  },
  {
    displayName: 'J-NET',
    logisticsCompany: 'CTR',
    serviceName: 'CTR_LAND_PICKUP',
    trackingNoRegex:
      '(^[a-zA-z]{2}[A-Za-z0-9]{9}[a-zA-z]{2}$|^[a-zA-z]{5}[0-9]{10}[a-zA-z]{2}$)',
  },
  {
    displayName: 'Correios Brazil',
    logisticsCompany: 'CORREIOS_BR',
    serviceName: 'CORREIOS_BR',
    trackingNoRegex: '(^[a-zA-z]{2}[0-9]{9}(BR)$)',
  },
  {
    displayName: 'EMS',
    logisticsCompany: 'EMS',
    serviceName: 'EMS',
    trackingNoRegex: '(^E[A-Za-z]{1}[0-9]{9}CN$)',
  },
  {
    displayName: 'e-EMS',
    logisticsCompany: 'EMS',
    serviceName: 'E_EMS',
    trackingNoRegex: '(^E[A-Za-z]{1}[0-9]{9}CN$)|(^FB[0-9]{9}CN$)',
  },
  {
    displayName: 'VietNam Post_VN',
    logisticsCompany: 'VNPOST_VN',
    serviceName: 'VNPOST_VN',
    trackingNoRegex: '（^RX[0-9]{9}VN$）',
  },
  {
    displayName: 'DHL',
    logisticsCompany: 'DHL',
    serviceName: 'DHL',
    trackingNoRegex: '^[0-9]{10}$',
  },
  {
    displayName: 'UPS Express Saver',
    logisticsCompany: 'UPS',
    serviceName: 'UPS',
    trackingNoRegex: '(^[a-zA-Z0-9]{11}$)|(^[a-zA-Z0-9]{18}$)',
  },
  {
    displayName: 'POSTKR',
    logisticsCompany: 'POSTKR',
    serviceName: 'POSTKR',
    trackingNoRegex: '(^[0-9]{13}$)|(^EE[0-9]{9}KR$)',
  },
  {
    displayName: 'CJ_LOGISTICS',
    logisticsCompany: 'CJ',
    serviceName: 'CJ',
    trackingNoRegex: '(^[0-9]{12}$)',
  },
  {
    displayName: 'UPS Expedited',
    logisticsCompany: 'UPS',
    serviceName: 'UPSE',
    trackingNoRegex: '(^[a-zA-Z0-9]{11}$)|(^[a-zA-Z0-9]{18}$)',
  },
  {
    displayName: 'Fedex IP',
    logisticsCompany: 'FEDEX',
    serviceName: 'FEDEX',
    trackingNoRegex: '(^[0-9]{12}$)|(^[0-9]{15}$)|(^[0-9]{20}$)|(^[0-9]{22}$)',
  },
  {
    displayName: 'Fedex IE',
    logisticsCompany: 'FEDEX',
    serviceName: 'FEDEX_IE',
    trackingNoRegex: '(^[0-9]{12}$)|(^[0-9]{15}$)|(^[0-9]{20}$)|(^[0-9]{22}$)',
  },
  {
    displayName: 'TNT_ES_LARGE',
    logisticsCompany: 'TNT_ES_LARGE',
    serviceName: 'TNT_ES_LARGE',
    trackingNoRegex: '(^[a-zA-Z]{2}[0-9]{9}[a-zA-Z]{2}$)|(^[0-9]{9}$)',
  },
  {
    displayName: 'DPEX',
    logisticsCompany: 'TOLL',
    serviceName: 'TOLL',
    trackingNoRegex: '(^[0-9]{12}$)',
  },
  {
    displayName: 'SF Express',
    logisticsCompany: 'SF',
    serviceName: 'SF',
    trackingNoRegex: '(^[a-zA-z0-9]{1,15}$)',
  },
  {
    displayName: "Seller's Shipping Method - IT",
    logisticsCompany: 'OTHER_IT',
    serviceName: 'OTHER_IT',
    trackingNoRegex: '(^[a-zA-Z0-9]{6,30}$)',
  },
  {
    displayName: "Seller's Shipping Method - ES",
    logisticsCompany: 'OTHER_ES',
    serviceName: 'OTHER_ES',
    trackingNoRegex: '(^[a-zA-Z0-9]{6,30}$)',
  },
  {
    displayName: "Seller's Shipping Method - FR",
    logisticsCompany: 'OTHER_FR',
    serviceName: 'OTHER_FR',
    trackingNoRegex: '(^[a-zA-Z0-9]{6,30}$)',
  },
  {
    displayName: "Seller's Shipping Method - DE",
    logisticsCompany: 'OTHER_DE',
    serviceName: 'OTHER_DE',
    trackingNoRegex: '(^[a-zA-Z0-9]{6,30}$)',
  },
  {
    displayName: "Seller's Shipping Method - RU",
    logisticsCompany: 'OTHER_RU',
    serviceName: 'OTHER_RU',
    trackingNoRegex: '(^[a-zA-Z0-9]{6,30}$)',
  },
  {
    displayName: 'IMILE_Express',
    logisticsCompany: 'IMILE_AE',
    serviceName: 'IMILE_AE',
    trackingNoRegex: '(^[a-zA-Z]{1,36}$)',
  },
  {
    displayName: 'SMSA Express',
    logisticsCompany: 'SMSA',
    serviceName: 'SMSA',
    trackingNoRegex: '(^[0-9]{12}$)',
  },
  {
    displayName: "Seller's Shipping Method",
    logisticsCompany: 'Other',
    serviceName: 'Other',
    trackingNoRegex: '(^[a-zA-Z0-9]{6,30}$)',
  },
  {
    displayName: "Seller's Shipping Method - US",
    logisticsCompany: 'OTHER_US',
    serviceName: 'OTHER_US',
    trackingNoRegex: '(^[a-zA-Z0-9]{6,31}$)',
  },
  {
    displayName: "Seller's Shipping Method - UK",
    logisticsCompany: 'OTHER_UK',
    serviceName: 'OTHER_UK',
    trackingNoRegex: '(^[a-zA-Z0-9]{6,30}$)',
  },
  {
    displayName: "Seller's Shipping Method - AU",
    logisticsCompany: 'OTHER_AU',
    serviceName: 'OTHER_AU',
    trackingNoRegex: '(^[a-zA-Z0-9]{6,30}$)',
  },
  {
    displayName: 'SHUNYOU_STANDARD_SG',
    logisticsCompany: 'SHUNYOU_STANDARD_SG',
    serviceName: 'SHUNYOU_STANDARD_SG',
    trackingNoRegex: '(^SYAE[a-zA-Z0-9]{9}$)',
  },
  {
    displayName: 'CAINIAO WAREHOUSE STANDARD SHIPPING',
    logisticsCompany: 'CAINIAO_OVERSEAS_WH_STDBE',
    serviceName: 'CAINIAO_OVERSEAS_WH_STDBE',
    trackingNoRegex: '^([a-zA-Z0-9]|[_-]){1,32}$',
  },
  {
    displayName: 'CAINIAO WAREHOUSE OVERSIZE SHIPPING',
    logisticsCompany: 'CAINIAO_OVERSEAS_WH_OSFR',
    serviceName: 'CAINIAO_OVERSEAS_WH_OSFR',
    trackingNoRegex: '^([a-zA-Z0-9]|[_-]){1,32}$',
  },
  {
    displayName: 'Cainiao Super Economy Global',
    logisticsCompany: 'AE_CN_SUPER_ECONOMY_G',
    serviceName: 'AE_CN_SUPER_ECONOMY_G',
    trackingNoRegex:
      '(^[A-Za-z0-9]{13}$)|(^LVS[0-9]{17})|(^[a-zA-z]{2}[0-9]{14}$)|(^[A-Za-z0-9]{15}$)|(^[a-zA-Z]{2}[0-9]{12}$)|(^N[0-9]{13}$)',
  },
  {
    displayName: 'CAINIAO WAREHOUSE OVERSIZE SHIPPING',
    logisticsCompany: 'CAINIAO_OVERSEAS_WH_OSES',
    serviceName: 'CAINIAO_OVERSEAS_WH_OSES',
    trackingNoRegex: '^([a-zA-Z0-9]|[_-]){1,32}$',
  },
  {
    displayName: 'CAINIAO WAREHOUSE EXPRESS SHIPPING',
    logisticsCompany: 'CAINIAO_OVERSEAS_WH_EXPIT',
    serviceName: 'CAINIAO_OVERSEAS_WH_EXPIT',
    trackingNoRegex: '^([a-zA-Z0-9]|[_-]){1,32}$',
  },
  {
    displayName: 'OWH_OVERSIZE',
    logisticsCompany: 'OWH_OVERSIZE',
    serviceName: 'OWH_OVERSIZE',
    trackingNoRegex: '(^21[0-9]{11}$)|(^908366[0-9]{7}$)|(^PSD[0-9]{12}$)',
  },
  {
    displayName: 'CAINIAO WAREHOUSE EXPRESS SHIPPING',
    logisticsCompany: 'CAINIAO_OVERSEAS_WH_EXPPL',
    serviceName: 'CAINIAO_OVERSEAS_WH_EXPPL',
    trackingNoRegex: '^([a-zA-Z0-9]|[_-]){1,32}$',
  },
  {
    displayName: 'CAINIAO WAREHOUSE STANDARD SHIPPING',
    logisticsCompany: 'CAINIAO_OVERSEAS_WH_STDUK',
    serviceName: 'CAINIAO_OVERSEAS_WH_STDUK',
    trackingNoRegex: '^([a-zA-Z0-9]|[_-]){1,32}$',
  },
  {
    displayName: 'CAINIAO WAREHOUSE STANDARD SHIPPING',
    logisticsCompany: 'CAINIAO_OVERSEAS_WH_STDPL',
    serviceName: 'CAINIAO_OVERSEAS_WH_STDPL',
    trackingNoRegex: '^([a-zA-Z0-9]|[_-]){1,32}$',
  },
  {
    displayName: 'CAINIAO TS90 STANDARD SHIPPING',
    logisticsCompany: 'CAINIAO_TS90_STANDARD',
    serviceName: 'CAINIAO_TS90_STANDARD',
    trackingNoRegex: '^([a-zA-Z0-9]|[_-]){1,32}$',
  },
  {
    displayName: 'CAINIAO WAREHOUSE OVERSIZE SHIPPING',
    logisticsCompany: 'CAINIAO_OVERSEAS_WH_OSUK',
    serviceName: 'CAINIAO_OVERSEAS_WH_OSUK',
    trackingNoRegex: '^([a-zA-Z0-9]|[_-]){1,32}$',
  },
  {
    displayName: 'CAINIAO WAREHOUSE EXPRESS SHIPPING',
    logisticsCompany: 'CAINIAO_OVERSEAS_WH_EXPFR',
    serviceName: 'CAINIAO_OVERSEAS_WH_EXPFR',
    trackingNoRegex: '^([a-zA-Z0-9]|[_-]){1,32}$',
  },
  {
    displayName: 'CAINIAO WAREHOUSE EXPRESS SHIPPING',
    logisticsCompany: 'CAINIAO_OVERSEAS_WH_EXPES',
    serviceName: 'CAINIAO_OVERSEAS_WH_EXPES',
    trackingNoRegex: '^([a-zA-Z0-9]|[_-]){1,32}$',
  },
  {
    displayName: 'Cainiao Standard - SG Air',
    logisticsCompany: 'CAINIAO_STANDARD_SG_AIR',
    serviceName: 'CAINIAO_STANDARD_SG_AIR',
    trackingNoRegex: '(^[a-zA-Z0-9]{1,36}$)',
  },
  {
    displayName: 'CAINIAO WAREHOUSE STANDARD SHIPPING',
    logisticsCompany: 'CAINIAO_OVERSEAS_WH_STDDE',
    serviceName: 'CAINIAO_OVERSEAS_WH_STDDE',
    trackingNoRegex: '^([a-zA-Z0-9]|[_-]){1,32}$',
  },
  {
    displayName: 'CAINIAO WAREHOUSE EXPRESS SHIPPING',
    logisticsCompany: 'CAINIAO_OVERSEAS_WH_EXPBE',
    serviceName: 'CAINIAO_OVERSEAS_WH_EXPBE',
    trackingNoRegex: '^([a-zA-Z0-9]|[_-]){1,32}$',
  },
  {
    displayName: 'CAINIAO WAREHOUSE STANDARD SHIPPING',
    logisticsCompany: 'CAINIAO_OVERSEAS_WH_STDCZ',
    serviceName: 'CAINIAO_OVERSEAS_WH_STDCZ',
    trackingNoRegex: '^([a-zA-Z0-9]|[_-]){1,32}$',
  },
  {
    displayName: 'CAINIAO WAREHOUSE STANDARD SHIPPING',
    logisticsCompany: 'CAINIAO_OVERSEAS_WH_STDFR',
    serviceName: 'CAINIAO_OVERSEAS_WH_STDFR',
    trackingNoRegex: '^([a-zA-Z0-9]|[_-]){1,32}$',
  },
  {
    displayName: 'CAINIAO WAREHOUSE STANDARD SHIPPING',
    logisticsCompany: 'CAINIAO_OVERSEAS_WH_STDES',
    serviceName: 'CAINIAO_OVERSEAS_WH_STDES',
    trackingNoRegex: '^([a-zA-Z0-9]|[_-]){1,32}$',
  },
];

export const weeks = [
  { label: '周一', value: '1' },
  { label: '周二', value: '2' },
  { label: '周三', value: '3' },
  { label: '周四', value: '4' },
  { label: '周五', value: '5' },
  { label: '周六', value: '6' },
  { label: '周日', value: '7' },
];
export const months = [
  { label: '1号', value: '1' },
  { label: '2号', value: '2' },
  { label: '3号', value: '3' },
  { label: '周四', value: '4' },
  { label: '周五', value: '5' },
  { label: '周六', value: '6' },
  { label: '周日', value: '7' },
];

export const countriesCN = {
  CN: 'China(中国)',
  AD: 'Andorra(安道尔)',
  AE: 'United Arab Emirates(阿拉伯联合酋长国)',
  AF: 'Afghanistan(阿富汗)',
  AG: 'Antigua and Barbuda(安提瓜和巴布达)',
  AI: 'Anguilla(安圭拉岛)',
  AL: 'Albania(阿尔巴尼亚)',
  AM: 'Armenia(亚美尼亚)',
  AN: 'Netherlands Antilles(荷属安的列斯群岛)',
  AO: 'Angola(安哥拉)',
  AQ: 'Antarctica(南极洲)',
  AR: 'Argentina(阿根廷)',
  AS: 'American Samoa(美属萨摩亚)',
  AT: 'Austria(奥地利)',
  AU: 'Australia(澳大利亚)',
  AW: 'Aruba(阿鲁巴岛)',
  AX: 'Aland Islands(奥兰群岛)',
  AZ: 'Azerbaijan(阿塞拜疆)',
  BA: 'Bosnia and Herzegovina(波黑)',
  BB: 'Barbados(巴巴多斯岛)',
  BD: 'Bangladesh(孟加拉共和国)',
  BE: 'Belgium(比利时)',
  BF: 'Burkina Faso(布基纳法索)',
  BG: 'Bulgaria(保加利亚)',
  BH: 'Bahrain(巴林)',
  BI: 'Burundi(布隆迪)',
  BJ: 'Benin(贝宁湾)',
  BL: 'Saint Barthélemy(圣巴茨岛)',
  BM: 'Bermuda(百慕大群岛)',
  BN: 'Brunei(文莱)',
  BO: 'Bolivia(玻利维亚)',
  BQ: 'British Antarctic Territory(英属南极领地)',
  BR: 'Brazil(巴西)',
  BS: 'Bahamas(巴哈马群岛)',
  BT: 'Bhutan(不丹)',
  BV: 'Bouvet Island(布韦岛)',
  BW: 'Botswana(博茨瓦纳)',
  BY: 'Belarus(白俄罗斯)',
  BZ: 'Belize(伯利兹)',
  CA: 'Canada(加拿大)',
  CC: 'Cocos Islands(科科斯群岛)',
  CD: 'Congo - Kinshasa(刚果（金）)',
  CF: 'Central African Republic(中非共和国)',
  CG: 'Congo - Brazzaville(刚果布)',
  CH: 'Switzerland(瑞士)',
  CI: "Cote d'Ivoire(科特迪瓦)",
  CK: 'Cook Islands(库克群岛)',
  CL: 'Chile(智利)',
  CM: 'Cameroon(喀麦隆)',
  CO: 'Colombia(哥伦比亚)',
  CR: 'Costa Rica(哥斯达黎加)',
  CS: 'Serbia and Montenegro(塞尔维亚和黑山)',
  CT: 'Canton and Enderbury Islands(广州和利群岛)',
  CU: 'Cuba(古巴)',
  CV: 'Cape Verde(佛得角)',
  CX: 'Christmas Island(圣诞岛)',
  CY: 'Cyprus(塞浦路斯)',
  CZ: 'Czech Republic(捷克)',
  DD: 'East Germany(东德)',
  DE: 'Germany(德国)',
  DJ: 'Djibouti(吉布提)',
  DK: 'Denmark(丹麦)',
  DM: 'Dominica(多米尼加)',
  DO: 'Dominican Republic(多米尼加共和国)',
  DZ: 'Algeria(阿尔及利亚)',
  EC: 'Ecuador(厄瓜多尔)',
  EE: 'Estonia(爱沙尼亚)',
  EG: 'Egypt(埃及)',
  EH: 'Western Sahara(西撒哈拉)',
  ER: 'Eritrea(厄立特里亚)',
  ES: 'Spain(西班牙)',
  ET: 'Ethiopia(埃塞俄比亚)',
  FI: 'Finland(芬兰)',
  FJ: 'Fiji(斐济)',
  FK: 'Falkland Islands(福克兰群岛)',
  FM: 'Micronesia(密克罗尼西亚)',
  FO: 'Faroe Islands(法罗群岛)',
  FQ: 'French Southern and Antarctic Territories(法国南方和南极领地)',
  FR: 'France(法国)',
  FX: 'Metropolitan France(法国本土)',
  GA: 'Gabon(加蓬)',
  GB: 'United Kingdom(UK)(英国)',
  GD: 'Grenada(格林纳达)',
  GE: 'Georgia(格鲁吉亚)',
  GF: 'French Guiana(法属圭亚那)',
  GG: 'Guernsey(根西岛)',
  GH: 'Ghana(加纳)',
  GI: 'Gibraltar(直布罗陀)',
  GL: 'Greenland(格陵兰)',
  GM: 'Gambia(冈比亚)',
  GN: 'Guinea(几内亚)',
  GP: 'Guadeloupe(瓜德罗普岛)',
  GQ: 'Equatorial Guinea(赤道几内亚)',
  GR: 'Greece(希腊)',
  GS: 'South Georgia and the South Sandwich Islands(南乔治亚岛与南桑威奇群岛)',
  GT: 'Guatemala(危地马拉)',
  GU: 'Guam(关岛)',
  GW: 'Guinea-Bissau(几内亚比绍共和国)',
  GY: 'Guyana(圭亚那)',
  HK: 'Hong Kong(中国香港特别行政区)',
  HM: 'Heard Island and McDonald Islands(赫德岛和麦克唐纳岛)',
  HN: 'Honduras(洪都拉斯)',
  HR: 'Croatia(克罗地亚)',
  HT: 'Haiti(海地)',
  HU: 'Hungary(匈牙利)',
  ID: 'Indonesia(印尼)',
  IE: 'Ireland(爱尔兰)',
  IL: 'Israel(以色列)',
  IM: 'Isle of Man(马恩岛)',
  IN: 'India(印度)',
  IO: 'British Indian Ocean Territory(英属印度洋领地)',
  IQ: 'Iraq(伊拉克共和国)',
  IR: 'Iran(伊朗)',
  IS: 'Iceland(冰岛)',
  IT: 'Italy(意大利)',
  JE: 'Jersey(泽西岛)',
  JM: 'Jamaica(牙买加)',
  JO: 'Jordan(约旦)',
  JP: 'Japan(日本)',
  JT: 'Johnston Island(约翰斯顿岛)',
  KE: 'Kenya(肯尼亚)',
  KG: 'Kyrgyzstan(吉尔吉斯斯坦)',
  KH: 'Cambodia(柬埔寨)',
  KI: 'Kiribati(基里巴斯)',
  KM: 'Comoros(科摩罗)',
  KN: 'Saint Kitts and Nevis(圣克里斯托弗和尼维斯岛)',
  KP: 'North Korea(朝鲜)',
  KR: 'South Korea(韩国)',
  KW: 'Kuwait(科威特)',
  KY: 'Cayman Islands(开曼群岛)',
  KZ: 'Kazakhstan(哈萨克斯坦)',
  LA: 'Laos(老挝国)',
  LB: 'Lebanon(黎巴嫩)',
  LC: 'Saint Lucia(圣卢西亚岛)',
  LI: 'Liechtenstein(列支敦斯登)',
  LK: 'Sri Lanka(斯里兰卡)',
  LR: 'Liberia(利比里亚)',
  LS: 'Lesotho(莱索托)',
  LT: 'Lithuania(立陶宛)',
  LU: 'Luxembourg(卢森堡)',
  LV: 'Latvia(拉脱维亚)',
  LY: 'Libya(利比亚)',
  MA: 'Morocco(摩洛哥)',
  MC: 'Monaco(摩纳哥)',
  MD: 'Moldova(摩尔多瓦)',
  ME: 'Montenegro(黑山共和国)',
  MF: 'Saint Martin(圣马丁岛)',
  MG: 'Madagascar(马达加斯加岛)',
  MH: 'Marshall Islands(马绍尔群岛)',
  MI: 'Midway Islands(中途岛)',
  MK: 'Macedonia(马其顿)',
  ML: 'Mali(马里)',
  MM: 'Myanmar(缅甸)',
  MN: 'Mongolia(蒙古)',
  MO: 'Macau(中国澳门特别行政区)',
  MP: 'Northern Mariana Islands(北马里亚纳群岛)',
  MQ: 'Martinique(马提尼克岛)',
  MR: 'Mauritania(毛利塔尼亚)',
  MS: 'Montserrat(蒙特塞拉特岛)',
  MT: 'Malta(马耳他)',
  MU: 'Mauritius(毛里求斯)',
  MV: 'Maldives(马尔代夫)',
  MW: 'Malawi(马拉维)',
  MX: 'Mexico(墨西哥)',
  MY: 'Malaysia(马来西亚)',
  MZ: 'Mozambique(莫桑比克)',
  NA: 'Namibia(纳米比亚)',
  NC: 'New Caledonia(新喀里多尼亚)',
  NE: 'Niger(尼日尔)',
  NF: 'Norfolk Island(诺福克岛)',
  NG: 'Nigeria(尼日利亚)',
  NI: 'Nicaragua(尼加拉瓜)',
  NL: 'Netherlands(荷兰)',
  NO: 'Norway(挪威)',
  NP: 'Nepal(尼泊尔)',
  NQ: 'Dronning Maud Land(毛德皇后地)',
  NR: 'Nauru(瑙鲁)',
  NT: 'Neutral Zone(中立区)',
  NU: 'Niue(纽埃岛)',
  NZ: 'New Zealand(新西兰)',
  OM: 'Oman(阿曼)',
  PA: 'Panama(巴拿马)',
  PC: 'Pacific Islands Trust Territory(太平洋岛屿托管领土)',
  PE: 'Peru(秘鲁)',
  PF: 'French Polynesia(法属玻利尼西亚)',
  PG: 'Papua New Guinea(巴布亚新几内亚)',
  PH: 'Philippines(菲律宾)',
  PK: 'Pakistan(巴基斯坦)',
  PL: 'Poland(波兰)',
  PM: 'Saint Pierre and Miquelon(圣皮埃尔和密克隆)',
  PN: 'Pitcairn(皮特克恩岛)',
  PR: 'Puerto Rico(波多黎各)',
  PS: 'Palestinian Territory(巴勒斯坦领土)',
  PT: 'Portugal(葡萄牙)',
  PU: 'U.S. Miscellaneous Pacific Islands(美控太平洋岛屿)',
  PW: 'Palau(帕劳群岛)',
  PY: 'Paraguay(巴拉圭)',
  PZ: 'Panama Canal Zone(巴拿马运河区)',
  QA: 'Qatar(卡塔尔)',
  QO: 'Outlying Oceania(边远的大洋洲)',
  QU: 'European Union(欧洲联盟)',
  RE: 'Reunion(留尼旺岛)',
  RO: 'Romania(罗马尼亚)',
  RS: 'Serbia(塞尔维亚)',
  RU: 'Russian Federation(俄罗斯)',
  RW: 'Rwanda(卢旺达)',
  SA: 'Saudi Arabia(沙特阿拉伯)',
  SB: 'Solomon Islands(所罗门群岛)',
  SC: 'Seychelles(塞舌尔)',
  SD: 'Sudan(苏丹)',
  SE: 'Sweden(瑞典)',
  SG: 'Singapore(新加坡)',
  SH: 'Saint Helena(圣赫勒拿岛)',
  SI: 'Slovenia(斯洛文尼亚)',
  SJ: 'Svalbard and Jan Mayen(斯瓦尔巴岛和扬马延岛)',
  SK: 'Slovakia(斯洛伐克)',
  SL: 'Sierra Leone(塞拉利昂)',
  SM: 'San Marino(圣马力诺)',
  SN: 'Senegal(塞内加尔)',
  SO: 'Somalia(索马里)',
  SR: 'Suriname(苏里南)',
  ST: 'Sao Tome and Principe(圣多美和普林西比)',
  SU: 'Union of Soviet Socialist Republics(苏联)',
  SV: 'El Salvador(萨尔瓦多)',
  SY: 'Syria(叙利亚)',
  SZ: 'Swaziland(斯威士兰)',
  TC: 'Turks and Caicos Islands(特克斯和凯科斯群岛)',
  TD: 'Chad(乍得湖)',
  TF: 'French Southern Territories(法属南半球领地)',
  TG: 'Togo(多哥)',
  TH: 'Thailand(泰国)',
  TJ: 'Tajikistan(塔吉克斯坦)',
  TK: 'Tokelau(托克劳群岛)',
  TL: 'East Timor(东帝汶)',
  TM: 'Turkmenistan(土库曼斯坦)',
  TN: 'Tunisia(突尼斯)',
  TO: 'Tonga(汤加)',
  TR: 'Turkey(土耳其)',
  TT: 'Trinidad and Tobago(特立尼达和多巴哥)',
  TV: 'Tuvalu(图瓦卢)',
  TW: 'Taiwan(中国台湾地区)',
  TZ: 'Tanzania(坦桑尼亚)',
  UA: 'Ukraine(乌克兰)',
  UG: 'Uganda(乌干达)',
  UM: 'United States Minor Outlying Islands(美国本土外小岛屿)',
  US: 'United States(USA, America)(美国)',
  UY: 'Uruguay(乌拉圭)',
  UZ: 'Uzbekistan(乌兹别克斯坦)',
  VA: 'Vatican(梵蒂冈)',
  VC: 'Saint Vincent and the Grenadines(圣文森特和格林纳丁斯)',
  VD: 'North Vietnam(北越)',
  VE: 'Venezuela(委内瑞拉)',
  VG: 'British Virgin Islands(英属维京群岛)',
  VI: 'U.S. Virgin Islands(美属维尔京群岛)',
  VN: 'Vietnam(越南)',
  VU: 'Vanuatu(瓦努阿图)',
  WF: 'Wallis and Futuna(瓦利斯群岛和富图纳群岛)',
  WK: 'Wake Island(威克岛)',
  WS: 'Samoa(萨摩亚群岛)',
  YD: "People's Democratic Republic of Yemen(也门人民民主共和国)",
  YE: 'Yemen(也门)',
  YT: 'Mayotte(马约特岛)',
  ZA: 'South Africa(南非)',
  ZM: 'Zambia(赞比亚)',
  ZW: 'Zimbabwe(津巴布韦)',
  RA: 'Remote area of us(美国偏远地区)',
};
